import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import { FC, useEffect, useMemo, useState, useCallback, useRef } from "react";
//import { PageViewportLayout } from "shared/components/template";
import { ProjectEditPageGrid, ProjectEditPageGridLabel, ProjectEditPageGridRow } from "shared/components/ProjectEditPageGrid";
import { DatePickerTeamWrapper, ProjectEditPageGridInput, ProjectEditPageGridList } from "_deziiign/books/pages/BookEdit/styles";
import { Input } from "@brg/input";
import { Lang, Form, FormAPI, API, Endpoints, TFile } from "@brg/api";
import { useTranslation } from "react-i18next";
import { CommonInput, CommonLabel, FlexBox, GridBox, HintTooltip, INPUT_TYPES, repeat, useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { BLanguageSelectionComponent } from "core/components/BLanguageSelectionComponent";
import { SaveUserLang } from "shared/components/__ADDONS__/__LANG__/Utils/GetUserLang";
import { setAppLang } from "shared/components/__ADDONS__/__LANG__/Slice";
import { MagicBoxRow } from "shared/components/MagicBoxRow";
import { LayoutConst, useModal } from "core";
import { DefaultButton, GridMobileNamed, MobileButtonsWrapper, TBody, TeamEditLabel, TeamsMobGridList } from "../styles";
import { JustTable } from "_competition/components/style";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import {ReactComponent as PlusSvg } from "../../projectEdit/close.svg";
import { InputTypes } from "../const/InputTypes";
import { FormCheckMarkPosition, DEFAULT_CHECK_MARK_POSITION, DEFAULT_CHECK_MARK_STATE } from "../const/FormCheckMarkPosition";
import styled from "styled-components";
import EditIcon24 from "shared/icons/EditIcon24";
import DeleteIcon from "shared/icons/DeleteIcon";
import { Date24Icon } from "shared/components/tagAdminProjectsSearchBar/date24";
import { Date32Icon } from "shared/components/tagAdminProjectsSearchBar/date32";
import CopySquareIcon24 from "shared/icons/CopySquareIcon24";
import { Utils } from "shared/helpers/utils/utils";
import { useUppyLoader } from "shared/hooks/useUppyLoader";
import useUploadValidator from "shared/hooks/useUploadValidator";
import { getProjectImages } from "shared/pages/project/sections/ps-image";
import SortableList, { SortableItem, SortableKnob } from "react-easy-sort";
import { arrayMoveImmutable } from "shared/utils/arrayMove";
import { DottedIcon } from "shared/icons/DottedIcon";
import { ITeamFilterModel } from "../types";
import { cloneValue } from "../helpers/cloneValue";
import setTextByLang, { getTextByLang } from "shared/helpers/setTextByLang";
import { normalizeUrl } from "shared/helpers/normalizeUrl";
import { CustomDateTimePicker } from "_competition/pages/CreateCompetitionPage/stylesEdit";
import { TeamAdminEditType } from "../types/types";
import { AdminEmailsToReceiveDataField } from "./AdminEmailsToReceiveDataField";

const Title = styled.h2`
    margin: 0 0 20px 0;
    font-size: 22px;
    font-weight: 600;
    color: #151514;
`;

const CopyIcon = styled.div`
     cursor: pointer;
`
const BorderBlock = styled(FlexBox)`
    padding: 24px;
    border: 1px solid #CDCDCD;
`

const CRM_ID_REG = /^[A-Za-zА-Яа-я]$/;

    const crmList = [
        {
            label: 'CRM design.hse.ru',
            value: 'designhse'
        }, 
        {
            label: 'CRM deziiign',
            value: 'burgundyproject1'
        },
        {
            label: 'CRM designkids.hse',
            value: 'unikhse'
        }
    ]

    const unisenderList = [
        {
            label: 'design.hse.ru',
            value: 'designhse'
        }, 
        {
            label: 'deziiign',
            value: 'burgundyproject1'
        },
        {
            label: 'designkids.hse',
            value: 'unikhse'
        }
    ]

export interface ITeamTab {
    path: string;
    name: LangObject[];
    about: LangObject[];
    filter: ITeamFilterModel;
    isMain: boolean;
}

type TeamFormsEditPropsT = {
    form: any;
    onUpdate: (val: any) => void;
    onClose?: () => void;
    editType?: TeamAdminEditType;
    onStatusSet: (val: string) => void;
    isChangesSaved?: boolean;
    setIsChangesSaved?: (value: boolean) => void;
    setIsFormFieldsFilled: (value: boolean) => void;
    canShowCrm?: boolean;
}

interface LocalizedText {
  lang: 'ru' | 'en';
  name: string;
}

interface FormField {
  type: number; 
  header: LocalizedText[];
  placeholder: LocalizedText[];
  isRequired: boolean;
  inlineVariants: unknown[];
  fieldIdInCrm: number | null;
  isTagInCrm?: boolean; 
}

const NEW_FIELD = { type: 0, header: createDefaultLangObject(''), placeholder: createDefaultLangObject(''), isRequired: true, isTagInCrm: false }

const FORM_FIELD_PLACEHOLDER_MAX_LENGTH = 60

const initialObject = [
    {
        "lang": "Ru",
        "name": ""
    },
    {
        "lang": "En",
        "name": ""
    }
]
const defaultNotificationSubject = [
    {
        "lang": "Ru",
        "name": "Ваше сообщение успешно получено"
    },
    {
        "lang": "En",
        "name": "Your message has been successfully received"
    }
]
const defaultNotificationText = [
    {
        "lang": "Ru",
        "name": "Спасибо, что поделились информацией. Мы ценим вашу вовлечённость и обязательно ознакомимся с вашим сообщением."
    },
    {
        "lang": "En",
        "name": "Thank you for sharing the information. We appreciate your involvement and will definitely review your message."
    }
]

const FormImageWrapper = styled(FlexBox)`
    position: relative;
    width: 100%;
`;

const FormImageId = styled.div`
    padding: 12px; 
    border-radius: 3px; 
    background-color: #F2F2F2;
    font-size: 13px;
    color: #151514;
    width: 100%;
    position: relative;
`;

const FormImageInput = styled.input`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 1;
    cursor: pointer;
`;

const LangRowLeadingSpacer = styled.div`
    min-width: 224px;
    margin-right: 16px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        min-width: 160px;
    }
`;

export const TeamFormsEdit: FC<TeamFormsEditPropsT> = (props) => {
    const { t, i18n } = useTranslation();
    const isMobile = useIsMobile();
    const modal = useModal();
    const toasts = useToasts();
    const is1280 = useBreakpoint(LayoutConst.screen.l_12);
    const isS = useBreakpoint(LayoutConst.screen.s);
    const [techName, setTechName] = useState<string>('');
    const [formAddress, setFormAddress] = useState<string>('');
    const [description, setDescription] = useState<LangObject[]>([]);
    const [header, setHeader] = useState<LangObject[]>([]);
    const [textOnComplete, setTextOnComplete] = useState<LangObject[]>([]);
    const [ppdWithCheckMark, setPpdWithCheckMark] = useState<LangObject[][]>([initialObject]);
    const [ppdCheckMarkPosition, setPpdCheckMarkPosition] = useState<FormCheckMarkPosition>(DEFAULT_CHECK_MARK_POSITION);
    const [ppdCheckMarkDefaultState, setPpdCheckMarkDefaultState] = useState<boolean>(DEFAULT_CHECK_MARK_STATE);
    const [textSubmitButton, setTextOnSubmitBtn] = useState<LangObject[]>([]);
    const [funnelId, setFunnelId] = useState('');
    const [unisenderListNumber, setUnisenderListNumber] = useState('');
    const [eventTheme, setEventTheme] = useState('');
    const [eventDate, setEventDate] = useState<Date | null>(null);
    const [eventTime, setEventTime] = useState('');
    const [eventFormat, setEventFormat] = useState('');
    const [eventPlace, setEventPlace] = useState('');
    const [price, setPrice] = useState('');
    const [pndFields, setPndFiels] = useState<LangObject[]>([]);
    const [emailNotificationSubject, setEmailNotificationSubject] = useState<LangObject[]>([]);
    const [emailNotificationText, setEmailNotificationText] = useState<LangObject[]>([]);
    const [emailSenderName, setEmailSenderName] = useState<string>('');
    const [adminEmailsToReceiveData, setAdminEmailsToReceiveData] = useState<string[]>([]);
    const [formFields, setFormFields] = useState<any>([]);
    const [crmName, setCrmName] = useState('');
    const [unisenderName, setUnisenderName] = useState('');
    const [registrationRequestLimit, setRegistrationRequestLimit] = useState<number | ''>('');
    const [isRegistrationRequestLimitVisible, setIsRegistrationRequestLimitVisible] = useState<boolean>(false);
    const [successButtonTitle, setSuccessButtonTitle] = useState<LangObject[]>([]);
    const [successButtonLink, setSuccessButtonLink] = useState<string>('');
    const { form, isChangesSaved, onUpdate, onStatusSet, setIsFormFieldsFilled, setIsChangesSaved, onClose, editType, canShowCrm = false } = props;
    const [sendingEmail, setSendingEmail] = useState('');
    const [shouldSendEmailNotification, setShouldSendEmailNotification] = useState(false);
    const [isRegisteredUsersOnly, setIsRegisteredUsersOnly] = useState(true);
    const [isFastRegisterWithEmail, setIsFastRegisterWithEmail] = useState(false);
    const [isProductPlatformForm, setIsProductPlatformForm] = useState(false);
    const [formTags, setFormTags] = useState([])
    
    const [priorPage, setPriorPage] = useState({
        title: [] as LangObject[],
        description: [] as LangObject[],
        buttonText: [] as LangObject[]
    });
    
    const [sortedData, setSortedData] = useState([]);
    const [priorPageImages, setPriorPageImages] = useState([]);
    const [time, setTime] = useState(Date.now());
    const [priorTime, setPriorTime] = useState(Date.now());
    const [files, setFiles] = useState([]);
    const [priorFiles, setPriorFiles] = useState([]);
    const fileRef = useRef<HTMLInputElement>(null);
    const priorFileRef = useRef<HTMLInputElement>(null);
    const validator = useUploadValidator(false, false);
    const images = getProjectImages(form, i18n.language) || [];
  
    

    const onUploadComplete = useCallback((uploadComplete: any) => {
        if (uploadComplete) {
            setFiles([]);
        }
    }, []);

    const [uppy, data] = useUppyLoader(files, fileRef, onUploadComplete, time);
    const [priorUppy, priorData] = useUppyLoader(priorFiles, priorFileRef, onUploadComplete, priorTime);

    useEffect(() => {
        if (data?.length > 0) {
            setSortedData(data);
        }
    }, [data]);

    useEffect(() => {
        if (priorData?.length > 0) {
            setPriorPageImages(priorData);
        }
    }, [priorData]);

    const onRemoveImage = useCallback((id: string, name: string) => {
        if (fileRef?.current) {
            fileRef.current.value = '';
        }
        uppy.removeFile(id);
        setTime(Date.now());
        setSortedData([]);
        setFiles([]);
    }, [fileRef, uppy]);

    const validateImageDimensions = (file: TFile): Promise<boolean> => {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                const isValid = img.height <= 200;
                resolve(isValid);
            };
            img.onerror = () => resolve(false);
            img.src = URL.createObjectURL(file);
        });
    };

    const onAddImage = useCallback(async (e: any) => {
        const newFiles = Array.from(e.target.files) as TFile[];

        if (fileRef?.current) {
            fileRef.current.value = '';
        }

        setTime(Date.now());

        let multipleFilesCheckResult: any = [];
        if (newFiles?.length > 0) {
            multipleFilesCheckResult = await Promise.all(
                newFiles.map(async (img: TFile) => {
                    const isValidFile = await validator([img]);
                    const isValidDimensions = await validateImageDimensions(img);
                    return isValidFile && isValidDimensions;
                })
            );
        }
        const allowed = await validator(files);

        if (!allowed || multipleFilesCheckResult?.includes(false)) {
            e.target.value = '';
            if (multipleFilesCheckResult?.includes(false)) {
                toasts.error(t('teams.adminPage.additionalFields.form_image_height_error'));
            }
            return;
        }

        if (files?.length > 0) {
            setFiles([]);
        }
        setSortedData([]);

        setTimeout(() => {
            setFiles(newFiles);
        }, 0);
    }, [files, fileRef, validator, onRemoveImage, toasts]);

    const handleRemoveFormImage = useCallback(() => {
        if (sortedData?.length > 0) {
            onRemoveImage(sortedData[0].id, sortedData[0].name);
        }
    }, [sortedData, onRemoveImage]);

    const onRemovePriorImage = useCallback((id: string, name: string) => {
        if (priorFileRef?.current) {
            priorFileRef.current.value = '';
        }
        priorUppy.removeFile(id);
        setPriorTime(Date.now());
        setPriorPageImages([]);
        setPriorFiles([]);
    }, [priorFileRef, priorUppy]);

    const onAddPriorImage = useCallback(async (e: any) => {
        const newFiles = Array.from(e.target.files) as TFile[];

        if (priorFileRef?.current) {
            priorFileRef.current.value = '';
        }

        setPriorTime(Date.now());

        let multipleFilesCheckResult: any = [];
        if (newFiles?.length > 0) {
            multipleFilesCheckResult = await Promise.all(
                newFiles.map(async (img: TFile) => {
                    return await validator([img]);
                })
            );
        }
        const allowed = await validator(priorFiles);

        if (!allowed || multipleFilesCheckResult?.includes(false)) {
            e.target.value = '';
            return;
        }

        if (priorFiles?.length > 0) {
            setPriorFiles([]);
        }
        setPriorPageImages([]);

        setTimeout(() => {
            setPriorFiles(newFiles);
        }, 0);
    }, [priorFiles, priorFileRef, validator]);

    const handleRemovePriorImage = useCallback(() => {
        if (priorPageImages?.length > 0) {
            onRemovePriorImage(priorPageImages[0].id, priorPageImages[0].name);
        }
    }, [priorPageImages, onRemovePriorImage]);
    
    useEffect(() => {
                API.request()
                    .endpoint(Endpoints.geoGateway)
                    .url(`/api/Forms/form-tags`)
                    .get()
                    .send()
                    .then((r: any) => r.json())
                    .then((r: any) => {
                        setFormTags(r);
                    }).catch((e: any) => {
                    console.log(e)
                })
        }, [])

    const inputTypes = (): { label: string, value: number }[] => {
        
        //@ts-ignore
        return Object.keys(InputTypes)
        ?.map((type, idx) => ({ label: t(`teams.adminPage.fields.inputs_types.${type.toLowerCase()}`), value: idx }))
        ?.filter((type, idx) => [0,1,2,3,4,6,8,9,10].includes(idx))
        ?.sort((a,b) => b.value === 1? 1 : b.value === 7 ? 0 : -1)
    }

    const getTypeName = (type: number): string => inputTypes()?.find((item) => item.value === type)?.label || '';

    const handleNewFieldClick = () => {
        setFormFields((prev: any[]) => [...(prev || []), { ...NEW_FIELD }])
    }

    const handleSetFormFieldChange = (idx: number, field: string, value: string | boolean, isLang?: boolean) => {
        const newList = formFields;
        setFormFields(newList.map((form: any, index: number, arr: any[]) => {
            if (index === idx) {
                return isLang ? {
                        ...form, 
                        //@ts-ignore
                        [field]: setTextByLang(arr[idx]?.[field], i18n.language, value) 
                    } : {
                        ...form, 
                        [field]: value 
                    }
            }
            return form
        }))
    }

    const handleEditDropdownInputs = (field: any, parentIdx: number) => {

        const handleSetDropdownVariants = (data: any, index: number) => {
            setFormFields((prev: any[]) => prev.map((item: any, i: number) => i === index ? data : item))
        }
        modal.show('form-dropdown-edit', {
            onAdd: (data: any, parentIdx: number) => handleSetDropdownVariants(data, parentIdx),
            parentIdx,
            field
        })
    }


    const handleDeleteFormFieldClick = (idx: number) => {
        setFormFields(formFields.filter((form: any, index: number) =>  index !== idx));
    }
    
    useEffect(() => {
        if (form) {
            const {
                title = '',
                description = '',
                buttonText = '',
                titleImages = []
                } = form?.priorPage || {};
            const textSubmitButton = form.textSubmitButton.some(
              (textSubmitButton: { name: string; lang: string }) =>
                textSubmitButton.name
            )
              ? form.textSubmitButton
              : [
                  { lang: "ru", name: "Отправить" },
                  { lang: "en", name: "Send" },
                ];
            setTechName(form.techName)
            if (form.formId && form.teamId) {
                setFormAddress(`${window.location.origin}/teams/form/${form.formId}`)
            } else {
                setFormAddress('')
            }
            setDescription(form.description ?? [])
            setHeader(form.header ?? [])
            setTextOnComplete(form.textOnComplete)
            setPpdWithCheckMark(form.ppdWithCheckMark || [initialObject]);
            //@ts-ignore
            setPpdCheckMarkPosition(form.ppdCheckMarkPosition ?? DEFAULT_CHECK_MARK_POSITION);
            //@ts-ignore
            setPpdCheckMarkDefaultState(form.ppdCheckMarkDefaultState ?? DEFAULT_CHECK_MARK_STATE);
            setIsRegisteredUsersOnly(form.isRegisteredUsersOnly)
            //@ts-ignore
            setIsFastRegisterWithEmail(form.IsFastRegisterWithEmail === true || form.isFastRegisterWithEmail === true)
            setShouldSendEmailNotification(form.shouldSendEmailNotification)
            setIsProductPlatformForm(form.isProductPlatformForm || false)
            setEmailNotificationSubject(form.emailNotificationSubject || initialObject)
            setEmailNotificationText(form.emailNotificationText || initialObject)
            setEmailSenderName(form.emailSenderName || '')
            //@ts-ignore
            setAdminEmailsToReceiveData(form.adminEmailsToReceiveData || [])
            setTextOnSubmitBtn(textSubmitButton)
            setPndFiels(form.pndFields?.[0]?.value || [])
            setFormFields(form.formFields);
            setCrmName(form?.crmName || '');
            setUnisenderName(form?.unisenderName || '');
            setUnisenderListNumber(form?.unisenderListNumber || '');
            setRegistrationRequestLimit(form?.registrationRequestLimit || '');
            setIsRegistrationRequestLimitVisible(form?.isRegistrationRequestLimitVisible || false);
            setEventTheme(form?.formEvent?.theme || '');
            setEventDate(form?.formEvent?.date ? new Date(form.formEvent.date) : null);
            setEventTime(form?.formEvent?.time || '');
            setEventFormat(form?.formEvent?.format || '');
            setEventPlace(form?.formEvent?.place || '');
            setPrice(form?.price || '');
            setSuccessButtonTitle(form?.successButtonTitle || []);
            setSuccessButtonLink(form?.successButtonLink || '');
            setFunnelId(
                form?.integration?.funnelId === 0 
                ? '' 
                : form?.integration?.funnelId)
            
            setPriorPage({
                title: title || [],
                description: description || [],
                buttonText: buttonText || []
            });
            
            if (form?.titleImages?.length && images) {
                const cleanFileId = images?.[0]?.fileId?.replace('_orig', '');
                const mockFile = {
                        id: cleanFileId,
                        name: t('teams.adminPage.fields.form_existing_image'),
                        src: images?.[0]?.url 
                    };
                    
                    setSortedData([mockFile]);
            } else {
                setSortedData([]);
            }

            if (titleImages?.length) {
                const cleanFileId = titleImages?.[0]?.fileId?.replace('_orig', '');
                const mockFile = {
                    id: cleanFileId,
                    name: t('teams.adminPage.fields.form_prior_page_image'),
                    src: titleImages?.[0]?.url
                };
                setPriorPageImages([mockFile]);
            } else {
                setPriorPageImages([]);
            }
        }
            } , [form?.formId])
        useEffect(() => {
            const requiredEmailNotification =  shouldSendEmailNotification
              ? !!Lang(emailNotificationText, i18n.language) &&
                  !!Lang(emailNotificationSubject, i18n.language)
              : true
            
            const requiredPriorPageFields = isRegisteredUsersOnly
              ? !!Lang(priorPage.title, i18n.language) &&
                !!Lang(priorPage.description, i18n.language) &&
                !!priorPageImages?.length &&
                !!Lang(priorPage.buttonText, i18n.language)
              : true
              
          setIsFormFieldsFilled(
            !!techName &&
              !!Lang(header, i18n.language) &&
              !!Lang(textOnComplete, i18n.language) &&
              !!Lang(textSubmitButton, i18n.language) &&
             requiredEmailNotification &&
             requiredPriorPageFields
          );
        }, [
          techName,
          header,
          textOnComplete,
          textSubmitButton,
          shouldSendEmailNotification,
          emailNotificationText,
          emailNotificationSubject,
          isRegisteredUsersOnly,
          priorPage.title,
          priorPage.description,
          priorPage.buttonText,
          priorPageImages,
        ]);
        
    // console.log('sortedData', sortedData);
    const isEmpty = (langObj: LangObject[]): boolean => {
        return langObj?.every((i) => i?.name === '') || !emailNotificationSubject?.length;
    }
    const handleDateChange = (value: Date | null) => {
        setEventDate(value);
    };
    const handleBlur = useCallback(() => {
        const minDate = new Date();

        if (eventDate && eventDate < minDate) {
            handleDateChange(minDate)
        }
    }, [eventDate]);

    const handleUnisenderListNumberChange = useCallback((ev: any) => {
        const sanitized = ev.target.value
            .replace(/[^\d,]/g, '')
            .replace(/,{2,}/g, ',');
        setUnisenderListNumber(sanitized);
    }, []);

    useEffect(() => {
        if (form && form.formId && isChangesSaved) {
            if (form && form.formId) {
                onStatusSet(t('saving'));
          
                const copy: Form<'Global'> = { ...form};
                //@ts-ignore
                copy.techName = techName;
                //@ts-ignore
                copy.formAddress = formAddress;
                copy.description = cloneValue(description);
                copy.header = cloneValue(header);
                copy.textOnComplete = cloneValue(textOnComplete);
                //@ts-ignore
                copy.ppdWithCheckMark = ppdWithCheckMark.map(field => cloneValue(field));
                //@ts-ignore
                copy.ppdCheckMarkPosition = ppdCheckMarkPosition;
                //@ts-ignore
                copy.ppdCheckMarkDefaultState = ppdCheckMarkDefaultState;
                //@ts-ignore
                copy.isRegisteredUsersOnly = isRegisteredUsersOnly;
                //@ts-ignore
                copy.IsFastRegisterWithEmail = isFastRegisterWithEmail;
                //@ts-ignore
                copy.shouldSendEmailNotification = shouldSendEmailNotification;
                //@ts-ignore
                copy.isProductPlatformForm = isProductPlatformForm;
                 //@ts-ignore
                copy.emailNotificationSubject = isEmpty(emailNotificationSubject) ? defaultNotificationSubject : cloneValue(emailNotificationSubject);
                //@ts-ignore
                copy.emailNotificationText = isEmpty(emailNotificationText) ? defaultNotificationText : cloneValue(emailNotificationText);
                //@ts-ignore
                copy.emailSenderName = emailSenderName;
                //@ts-ignore
                copy.adminEmailsToReceiveData = adminEmailsToReceiveData;
                copy.textSubmitButton = cloneValue(textSubmitButton);
                copy.pndFields = [ { name: [...cloneValue(pndFields)], value: [...cloneValue(pndFields)] } ]
                //@ts-ignore
                copy.formFields = formFields;
                //@ts-ignore
                copy.successButtonTitle = cloneValue(successButtonTitle);
                //@ts-ignore
                copy.successButtonLink = successButtonLink;
                //@ts-ignore
                copy.price = Number(price);
                //@ts-ignore
                copy.unisenderListNumber = unisenderListNumber.trim().replace(/^,+|,+$/g, '');
                //@ts-ignore
                copy.unisenderName = !!unisenderName?.length ? unisenderName : '';
                 //@ts-ignore
                copy.formEvent = {
                    theme: eventTheme,
                    date: eventDate,
                    time: eventTime,
                    format: eventFormat,
                    place: eventPlace
                };
                //@ts-ignore
                copy.crmName = !!crmName?.length ? crmName : ''
                //@ts-ignore
                copy.registrationRequestLimit = registrationRequestLimit || null;
                //@ts-ignore
                copy.isRegistrationRequestLimitVisible = isRegistrationRequestLimitVisible;
                //@ts-ignore
                copy.priorPage = {
                    title: cloneValue(priorPage.title),
                    description: cloneValue(priorPage.description),
                    buttonText: cloneValue(priorPage.buttonText),
                };

                if (sendingEmail?.length) {
                    //@ts-ignore
                    copy.emailOptions = {
                        shouldNotify: true,
                        letterText: sendingEmail
                    }
                }
                
                if (sortedData?.length > 0) {
                    const cleanFileId = images?.[0]?.fileId?.replace('_orig', '');
                    const sameImage = sortedData[0].id === cleanFileId
                    //@ts-ignore
                    copy.headerImage = sameImage ? null : sortedData[0]?.id;
                }

                if (priorPageImages?.length > 0) {
                    //@ts-ignore
                    copy.priorPage.titleImage = priorPageImages[0]?.id;
                }
                
                copy.integration = { 
                    ...form?.integration, 
                    ...(!!funnelId?.length ? { funnelId: Number(funnelId) } : {}),
                }

                FormAPI.Update(copy).then((r) => {
                    setTimeout(() => onStatusSet(t('editing_saved')), 1000)
                    onUpdate(Date.now())
                    onClose?.()
                })

            } 
        }

    }, [description, header, textOnComplete, ppdWithCheckMark, ppdCheckMarkPosition, ppdCheckMarkDefaultState, isRegisteredUsersOnly, isFastRegisterWithEmail, shouldSendEmailNotification, isProductPlatformForm, emailNotificationSubject, emailNotificationText, emailSenderName, adminEmailsToReceiveData, formFields, pndFields, techName, formAddress, textSubmitButton, funnelId, unisenderListNumber, unisenderName, registrationRequestLimit, isRegistrationRequestLimitVisible, isChangesSaved, sortedData, priorPage, priorPageImages, successButtonTitle, successButtonLink]);
    
     const registeredUsersOnly = useMemo(() => {
    
            return (
                <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.registed_user_only')}
                        infoText={t('teams.adminPage.additionalFields.registed_user_only_msg')}
                        onWhiteBG
                        fixedHeight
                    />
                    <ProjectEditPageGridInput isTeamEdit isCheckbox>
                        <MagicBoxRow
                            className={'checkbox'}
                            checked={isRegisteredUsersOnly}
                            label={''}
                            onClick={() => {
                                const newValue = !isRegisteredUsersOnly;
                                setIsRegisteredUsersOnly(newValue);
                                // При включении "только для зарегистрированных" отключаем быструю регистрацию
                                if (newValue) {
                                    setIsFastRegisterWithEmail(false);
                                }
                            }}
                            isTeamEdit
                        />
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>
            )
        }, [isRegisteredUsersOnly, isS, t])

     const fastRegisterWithEmail = useMemo(() => {
            // Показываем только когда отключен чекбокс "Заполнение формы только авторизованным пользователям"
            if (isRegisteredUsersOnly) {
                return null;
            }

            return (
                <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.fast_register_with_email')}
                        infoText={t('teams.adminPage.additionalFields.fast_register_with_email_msg')}
                        onWhiteBG
                        fixedHeight
                    />
                    <ProjectEditPageGridInput isTeamEdit isCheckbox>
                        <MagicBoxRow
                            className={'checkbox'}
                            checked={isFastRegisterWithEmail}
                            label={''}
                            onClick={() => {
                                const newValue = !isFastRegisterWithEmail;
                                
                                if (newValue) {
                                    const emailFieldExists = formFields.some((field: FormField) => {
                                        return field.type === 2
                                    });
                                    
                                    if (!emailFieldExists) {
                                        const newEmailField = {
                                            type: 2,
                                            header: [
                                                { lang: "ru", name: "Почта" },
                                                { lang: "en", name: "" }
                                            ],
                                            placeholder: [
                                                { lang: "Ru", name: "" },
                                                { lang: "En", name: "" }
                                            ],
                                            isRequired: true,
                                            isTagInCrm : false,
                                            inlineVariants: [],
                                            fieldIdInCrm: null,
                                        };                                       
                                        setFormFields([...formFields, newEmailField]);
                                    }
                                }
                        
                                setIsFastRegisterWithEmail(newValue);
                            }}
                            isTeamEdit
                        />
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>
            )
        }, [isFastRegisterWithEmail, isRegisteredUsersOnly, formFields, isS, t])

     const iSSendEmailNotification = useMemo(() => {
    
            return (
                <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.email_notification')}
                        infoText={t('teams.adminPage.additionalFields.send_email_msg')}
                        onWhiteBG
                        fixedHeight
                    />
                    <ProjectEditPageGridInput isTeamEdit isCheckbox>
                        <MagicBoxRow
                            className={'checkbox'}
                            checked={shouldSendEmailNotification}
                            label={''}
                            onClick={() => {
                                const newValue = !shouldSendEmailNotification;
                                
                                if (newValue) {
                                    // Добавляем email-поле, если его нет
                                    const emailFieldExists = formFields.some((field: FormField) => {
                                        
                                        return field.type === 2
                                    });
                                    if (!emailFieldExists) {
                                        const newEmailField = {
                                            type: 2,
                                            header: [
                                                { lang: "ru", name: "Почта" },
                                                { lang: "en", name: "" }
                                            ],
                                            placeholder: [
                                                { lang: "Ru", name: "" },
                                                { lang: "En", name: "" }
                                            ],
                                            isRequired: true,
                                            isTagInCrm : false,
                                            inlineVariants: [],
                                            fieldIdInCrm: null,
                                        };                                       
                                        setFormFields([...formFields, newEmailField]);
                                    }
                                }
                        
                                setShouldSendEmailNotification(newValue);
                            }}
                            isTeamEdit
                        />
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>
            )
        }, [shouldSendEmailNotification, formFields, isS, t])

    const isProductPlatformFormField = useMemo(() => {
        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.product_platform_form')}
                    infoText={t('teams.adminPage.additionalFields.product_platform_form_msg')}
                    onWhiteBG
                    fixedHeight
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={isProductPlatformForm}
                        label={''}
                        onClick={() => setIsProductPlatformForm(!isProductPlatformForm)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isProductPlatformForm, isS, t])

    const event = useMemo(() => {

            return (
                <>
                <BorderBlock offsetTop={24} direction="column">
                    <CommonLabel 
                        label={t('teams.adminPage.fields.event')}
                        infoText={t('teams.adminPage.additionalFields.event_msg')}
                        fixedHeight
                        onWhiteBG
                    />
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        orientation="wide"
                        label={t('teams.adminPage.fields.event_price')}
                        value={price}
                        infoText={t('teams.adminPage.additionalFields.price_msg')}
                        onWhiteBG
                        onChange={(ev: any) => {
                            const value = ev.target.value;
                            if (value === '' || /^[0-9]+$/.test(value)) {
                                setPrice(value);
                            }
                        }}
                    />
                </ProjectEditPageGridRow>
                <FlexBox wrap="wrap" justify="space-between">
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.event_theme')}
                        orientation="wide"
                        value={eventTheme}
                        onChange={(ev: any) => setEventTheme(ev.target.value)}
                    />
                </ProjectEditPageGridRow>
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.event_format')}
                        orientation="wide"
                        value={eventFormat}
                        onChange={(ev: any) => setEventFormat(ev.target.value)}
                    />
                </ProjectEditPageGridRow>
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.event_date')}
                        fixedHeight
                    />
                    <DatePickerTeamWrapper formEdit>
                         <CustomDateTimePicker
                            value={eventDate || undefined}
                            className="date-input"
                            calendarIcon={isMobile ? <Date24Icon />  : <Date32Icon />}
                            clearIcon={null}
                            format="dd-MM-yyyy"
                            minDate={new Date()}
                            // maxDate={addYears(new Date(), 5)}
                            locale={i18n.language}
                            onChange={handleDateChange}
                            onCalendarClose={handleBlur}
                            isFormPage
                            />
                    </DatePickerTeamWrapper>
                </ProjectEditPageGridRow>
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.event_time')}
                        fixedHeight
                    />
                    <ProjectEditPageGridInput>
                        <Input.Text
                            type="time"
                            value={eventTime}
                            onChange={(ev: any) => setEventTime(ev.target.value)}
                        />
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>
                
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.event_place')}
                        orientation="wide"
                        value={eventPlace}
                        onChange={(ev: any) => setEventPlace(ev.target.value)}
                    />
                </ProjectEditPageGridRow>
                </FlexBox>
                </BorderBlock>
                </>
            )
        }, [eventDate, eventFormat, eventPlace, eventTheme, price, eventTime, handleBlur, i18n.language, isMobile])

    const previewPageFields = useMemo(() => {
        return(
            <>
            <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.prior_page_title')}
                        maxLength={100}
                        value={Lang(priorPage.title, i18n.language)}
                        onChange={(ev: any) => setPriorPage({
                            ...priorPage,
                            title: setTextByLang(priorPage.title, i18n.language, ev.target.value)
                        })}
                        orientation="wide"
                        required
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.textarea}
                        label={t('teams.adminPage.fields.prior_page_description')}
                        maxLength={500}
                        className="form-textarea"
                        value={getTextByLang(priorPage.description, i18n.language)}
                        onChange={(ev: any) => setPriorPage({
                            ...priorPage,
                            description: setTextByLang(priorPage.description, i18n.language, ev.target.value)
                        })}
                        orientation="wide"
                        required
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.prior_page_image')}
                        infoText={t('teams.adminPage.additionalFields.prior_page_image_info')}
                        onWhiteBG
                        fixedHeight
                        required
                    />
                    <ProjectEditPageGridInput>
                        <FormImageWrapper  gx={8} align="center">
                            {priorPageImages?.length > 0 ? (
                                <>
                                    <FormImageId>
                                        {priorPageImages[0]?.name || t('teams.adminPage.fields.form_file_not_selected')}
                                        <FormImageInput
                                            ref={priorFileRef}
                                            type="file"
                                            accept="image/jpeg, image/gif, image/png"
                                            onChange={onAddPriorImage}
                                        />
                                    </FormImageId>
                                    <FlexBox gx={8}>
                                        <DefaultButton 
                                            wh={131} 
                                            whMob={107} 
                                            onClick={() => priorFileRef.current?.click()}
                                        >
                                            {t('teams.adminPage.fields.form_change')}
                                        </DefaultButton>
                                        <DefaultButton 
                                            wh={131} 
                                            whMob={107} 
                                            onClick={handleRemovePriorImage}
                                            style={{ backgroundColor: '#FF4444', color: 'white' }}
                                        >
                                            {t('teams.adminPage.fields.form_delete')}
                                        </DefaultButton>
                                    </FlexBox>
                                </>
                            ) : (
                                <>
                                    <DefaultButton 
                                        wh={131} 
                                        whMob={107} 
                                        onClick={() => priorFileRef.current?.click()}
                                    >
                                        {t('teams.adminPage.fields.form_add')}
                                    </DefaultButton>
                                    <FormImageInput
                                        ref={priorFileRef}
                                        type="file"
                                        accept="image/jpeg, image/gif, image/png"
                                        onChange={onAddPriorImage}
                                    />
                                </>
                            )}
                        </FormImageWrapper>
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.prior_page_button_title')}
                        maxLength={50}
                        value={getTextByLang(priorPage.buttonText, i18n.language)}
                        onChange={(ev: any) => setPriorPage({
                            ...priorPage,
                            buttonText: setTextByLang(priorPage.buttonText, i18n.language, ev.target.value)
                        })}
                        orientation="wide"
                        required
                    />
                </ProjectEditPageGridRow>
                </>
        )
    }, [priorPage, priorPageImages])
        
    const handleAddPpdField = () => {
        if (ppdWithCheckMark.length < 3) {
            setPpdWithCheckMark([...ppdWithCheckMark, initialObject]);
        }
    };

    const handleRemovePpdField = (index: number) => {
        if (ppdWithCheckMark.length > 1) {
            setPpdWithCheckMark(ppdWithCheckMark.filter((_, i) => i !== index));
        }
    };

    const handlePpdFieldChange = (index: number, value: string) => {
        const newPpdFields = [...ppdWithCheckMark];
        newPpdFields[index] = setTextByLang(newPpdFields[index], i18n.language, value);
        setPpdWithCheckMark(newPpdFields);
    };

    const handleCopyFormAddress = () => {
        if (formAddress) {
            navigator.clipboard.writeText(formAddress).then(() => {
                toasts.info(t('link_copied'));
            });
        }
    };
     const handlePathBlur = useCallback(() => {
        if (!successButtonLink) return;

        const normalizedUrl = normalizeUrl(successButtonLink);
        
        if (normalizedUrl !== successButtonLink) {
            setSuccessButtonLink(normalizedUrl);
        }
    }, [successButtonLink]);

    const onMoveOption = useCallback((oldIndex: number, newIndex: number) => {
        const newOpt = arrayMoveImmutable(formFields, oldIndex, newIndex)
        setFormFields(newOpt);
    } , [formFields])
    
    return (
        <>
        {/*<PageViewportLayout offsetTop={40}>*/}
            
            <ProjectEditPageGrid isTeamPage offsetBottom={80}>
                
                {editType !== TeamAdminEditType.SIMPLY && (
                    <Title>
                        {t('teams.adminPage.additionalFields.form_title')}
                    </Title>
                )}

                <ProjectEditPageGridRow isTeamEdit style={{flexDirection: 'row'}}>
                    {!isS && <LangRowLeadingSpacer />}
                    <FlexBox width={'100%'}  widthMobile={isS ? '100%' : '558px'} style={{ maxWidth: isS ? '100%' : '600px' }} >
                        <BLanguageSelectionComponent
                            isProjectPage={true}
                            onLangSelect={(lang) => {
                                SaveUserLang(lang as 'en' | 'ru');
                                setAppLang(lang);
                                i18n.changeLanguage(lang);
                            }}
                            key={'lang'}
                            fs={true}
                        />
                    </FlexBox>
                </ProjectEditPageGridRow>         
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.form_name')}
                        maxLength={50}
                        value={techName}
                        onChange={(ev: any) => setTechName(ev.target.value)}
                        orientation="wide"
                        required
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.form_header')}
                        maxLength={200}
                        value={getTextByLang(header, i18n.language)}
                        onChange={(ev: any) => setHeader(setTextByLang(header, i18n.language, ev.target.value))}
                        orientation="wide"
                        required
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.textarea}
                        label={t('teams.adminPage.fields.form_text')}
                        maxLength={800}
                        className="form-textarea"
                        value={getTextByLang(description, i18n.language)}
                        onChange={(ev: any) => setDescription(setTextByLang(description, i18n.language, ev.target.value))}
                        orientation="wide"
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.form_image')}
                        infoText={t('teams.adminPage.additionalFields.form_image_info')}
                        onWhiteBG
                        fixedHeight
                    />
                    <ProjectEditPageGridInput>
                        <FormImageWrapper  gx={8} align="center">
                            {sortedData?.length > 0 ? (
                                <>
                                    <FormImageId>
                                        {sortedData[0]?.name || t('teams.adminPage.fields.form_file_not_selected')}
                                        <FormImageInput
                                            ref={fileRef}
                                            type="file"
                                            accept="image/jpeg, image/gif, image/png"
                                            onChange={onAddImage}
                                        />
                                    </FormImageId>
                                    <FlexBox gx={8}>
                                        <DefaultButton 
                                            wh={131} 
                                            whMob={107} 
                                            onClick={() => fileRef.current?.click()}
                                        >
                                            {t('teams.adminPage.fields.form_change')}
                                        </DefaultButton>
                                        <DefaultButton 
                                            wh={131} 
                                            whMob={107} 
                                            onClick={handleRemoveFormImage}
                                            style={{ backgroundColor: '#FF4444', color: 'white' }}
                                        >
                                            {t('teams.adminPage.fields.form_delete')}
                                        </DefaultButton>
                                    </FlexBox>
                                </>
                            ) : (
                                <>
                                    <DefaultButton 
                                        wh={131} 
                                        whMob={107} 
                                        onClick={() => fileRef.current?.click()}
                                    >
                                        {t('teams.adminPage.fields.form_add')}
                                    </DefaultButton>
                                    <FormImageInput
                                        ref={fileRef}
                                        type="file"
                                        accept="image/jpeg, image/gif, image/png"
                                        onChange={onAddImage}
                                    />
                                </>
                            )}
                        </FormImageWrapper>
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>
                
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <FlexBox style={{ gap: '8px', alignItems: 'center', width: '100%' }}>
                        <CommonInput 
                            type={INPUT_TYPES.text}
                            label={t('teams.adminPage.fields.form_address')}
                            infoText={t('teams.adminPage.additionalFields.form_link_msg')}
                            onWhiteBG
                            maxLength={200}
                            value={formAddress}
                            disable
                            onChange={(ev: any) => setFormAddress(ev.target.value)}
                            orientation="wide"
                        />
                        <CopyIcon onClick={handleCopyFormAddress}>
                            <HintTooltip positionY="top" text={t('teams.adminPage.fields.form_copy_link')} z={6} onWhiteBg={true}>
                                <CopySquareIcon24  fill="#151514" />
                            </HintTooltip>
                        </CopyIcon>
                    </FlexBox>
                </ProjectEditPageGridRow>
                
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.form_submit_button_text')}
                        maxLength={10}
                        value={getTextByLang(textSubmitButton, i18n.language)}
                        onChange={(ev: any) => setTextOnSubmitBtn(setTextByLang(textSubmitButton, i18n.language, ev.target.value))}
                        orientation="wide"
                        required
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.form_registration_limit')}
                        infoText={t('teams.adminPage.additionalFields.form_registration_limit_info')}
                        onWhiteBG
                        maxLength={10}
                        value={registrationRequestLimit}
                        onChange={(ev: any) => {
                            const value = ev.target.value;
                            if (value === '' || /^[0-9]+$/.test(value)) {
                                const numValue = Number(value);
                                if (value === '' || numValue > 0) {
                                    setRegistrationRequestLimit(value === '' ? '' : numValue);
                                }
                            }
                        }}
                        orientation="wide"
                    />
                </ProjectEditPageGridRow>
                {!!registrationRequestLimit && (
                    <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit isCheckbox>
                        <CommonLabel 
                            label={t('teams.adminPage.fields.form_show_free_places')}
                            onWhiteBG
                            fixedHeight
                        />
                        <ProjectEditPageGridInput isTeamEdit isCheckbox>
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={isRegistrationRequestLimitVisible}
                                label={''}
                                onClick={() => setIsRegistrationRequestLimitVisible(!isRegistrationRequestLimitVisible)}
                                isTeamEdit
                            />
                        </ProjectEditPageGridInput>
                    </ProjectEditPageGridRow>
                )}
                
                
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.textarea}
                        label={t('teams.adminPage.fields.form_completion_message')}
                        maxLength={200}
                        className="form-textarea"
                        value={getTextByLang(textOnComplete, i18n.language)}
                        onChange={(ev: any) => setTextOnComplete(setTextByLang(textOnComplete, i18n.language, ev.target.value))}
                        orientation="wide"
                        required
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.form_success_button_title')}
                        maxLength={30}
                        infoText={t('teams.adminPage.additionalFields.form_success_button_title_info')}
                        onWhiteBG
                        value={getTextByLang(successButtonTitle, i18n.language)}
                        onChange={(ev: any) => setSuccessButtonTitle(setTextByLang(successButtonTitle, i18n.language, ev.target.value))}
                        orientation="wide"
                        placeholder={t('teams.adminPage.fields.form_close')}
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.form_success_button_link')}
                        infoText={t('teams.adminPage.additionalFields.form_success_button_link_info')}
                        onWhiteBG
                        value={successButtonLink}
                        onChange={(ev: any) => setSuccessButtonLink(ev.target.value)}
                        onBlur={handlePathBlur}
                        orientation="wide"
                    />
                </ProjectEditPageGridRow>
                
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.textarea}
                        label={t('teams.adminPage.fields.form_pnd_agreement')}
                        maxLength={300}
                        infoText={t('teams.adminPage.additionalFields.pndFields_msg')}
                        onWhiteBG
                        //@ts-ignore
                        value={getTextByLang(pndFields, i18n.language)}
                        //@ts-ignore
                        onChange={(ev: any) => setPndFiels(setTextByLang(pndFields, i18n.language, ev.target.value))}
                        orientation="wide"
                    />
                </ProjectEditPageGridRow>
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.form_pnd_agreement_with_checkbox')}
                        fixedHeight
                        infoText={t('teams.adminPage.additionalFields.ppdWithCheckMark_msg')}
                        onWhiteBG
                    />
                    <ProjectEditPageGridInput direction="column">
                        {ppdWithCheckMark.map((ppdField, index) => (
                            <FlexBox key={index} direction="column" offsetTop={index > 0 ? 16 : 0}>
                                <FlexBox align="center">
                                    <CommonInput 
                                        type={INPUT_TYPES.textarea}
                                        maxLength={1200}
                                        className="form-textarea"
                                        value={getTextByLang(ppdField, i18n.language)}
                                        onChange={(ev: any) => handlePpdFieldChange(index, ev.target.value)}
                                        orientation="wide"
                                    />
                                    {ppdWithCheckMark.length > 1 && (
                                        <DefaultButton 
                                            wh={100} 
                                            onClick={() => handleRemovePpdField(index)}
                                            style={{ marginLeft: 16, alignSelf: 'flex-end' }}
                                        >
                                            {t('teams.adminPage.fields.form_delete')}
                                        </DefaultButton>
                                    )}
                                </FlexBox>
                            </FlexBox>
                        ))}
                        {ppdWithCheckMark.length < 3 && (
                            <FlexBox offsetTop={16}>
                                <DefaultButton wh={180} onClick={handleAddPpdField}>
                                    {t('teams.adminPage.fields.form_add_agreement')}
                                </DefaultButton>
                            </FlexBox>
                        )}
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                    <CommonLabel
                        label={t('teams.adminPage.fields.form_ppd_check_mark_position')}
                        infoText={t('teams.adminPage.additionalFields.form_ppd_check_mark_position_msg')}
                        onWhiteBG
                        fixedHeight
                    />
                    <ProjectEditPageGridInput isTeamEdit isCheckbox>
                        <MagicBoxRow
                            className={'checkbox'}
                            checked={ppdCheckMarkPosition === FormCheckMarkPosition.Left}
                            label={''}
                            onClick={() => {
                                setPpdCheckMarkPosition(
                                    ppdCheckMarkPosition === FormCheckMarkPosition.Left
                                        ? FormCheckMarkPosition.Right
                                        : FormCheckMarkPosition.Left
                                );
                            }}
                            isTeamEdit
                        />
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                    <CommonLabel
                        label={t('teams.adminPage.fields.form_ppd_check_mark_default_state')}
                        infoText={t('teams.adminPage.additionalFields.form_ppd_check_mark_default_state_msg')}
                        onWhiteBG
                        fixedHeight
                    />
                    <ProjectEditPageGridInput isTeamEdit isCheckbox>
                        <MagicBoxRow
                            className={'checkbox'}
                            checked={ppdCheckMarkDefaultState}
                            label={''}
                            onClick={() => setPpdCheckMarkDefaultState(!ppdCheckMarkDefaultState)}
                            isTeamEdit
                        />
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>

                {registeredUsersOnly}
                {fastRegisterWithEmail}
                {iSSendEmailNotification}
                {isProductPlatformFormField}
                {isRegisteredUsersOnly && previewPageFields}

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.textarea}
                        label={t('teams.adminPage.fields.form_email_sender_name')}
                        infoText={t('teams.adminPage.additionalFields.form_email_sender_name_info')}
                        onWhiteBG
                        maxLength={100}
                        //@ts-ignore
                        value={emailSenderName}
                        //@ts-ignore
                        onChange={(ev: any) => setEmailSenderName(ev.target.value)}
                        orientation="wide"
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.textarea}
                        label={t('teams.adminPage.fields.form_email_notification_subject')}
                        maxLength={300}
                        //@ts-ignore
                        value={getTextByLang(emailNotificationSubject, i18n.language)}
                        //@ts-ignore
                        onChange={(ev: any) => setEmailNotificationSubject(setTextByLang(emailNotificationSubject, i18n.language, ev.target.value))}
                        orientation="wide"
                        required={shouldSendEmailNotification}
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.textarea}
                        label={t('teams.adminPage.fields.form_email_notification_text')}
                        maxLength={300}
                        //@ts-ignore
                        value={getTextByLang(emailNotificationText, i18n.language)}
                        //@ts-ignore
                        onChange={(ev: any) => setEmailNotificationText(setTextByLang(emailNotificationText, i18n.language, ev.target.value))}
                        orientation="wide"
                        required={shouldSendEmailNotification}
                    />
                </ProjectEditPageGridRow>

                <AdminEmailsToReceiveDataField
                    value={adminEmailsToReceiveData}
                    onChange={setAdminEmailsToReceiveData}
                />

            {canShowCrm && (
            <BorderBlock offsetTop={24} direction="column">
                <CommonLabel 
                        label={t('teams.adminPage.fields.crm')}
                        fixedHeight
                    />
                <ProjectEditPageGridRow isTeamEdit>
                    <CommonInput 
                            type={INPUT_TYPES.dropdown}
                            label={t('teams.adminPage.fields.form_send_to_crm')}
                            options={crmList}
                            value={crmList.find(({ value }) => value === crmName)}
                            onChange={(item: any) => setCrmName(item?.value)}
                            placeholder={t('teams.adminPage.fields.form_select_crm')}
                            orientation="wide"
                        />
                </ProjectEditPageGridRow>

                    <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                        <CommonInput 
                            type={INPUT_TYPES.text}
                            label={t('teams.adminPage.fields.form_amo_crm_funnel_id')}
                            maxLength={9}
                            value={funnelId}
                            onChange={(ev: any) => {
                              if (!crmName?.length) return;
                              const v = ev.target.value;
                              if (v === '' || !Number.isNaN(Number(v))) {
                                setFunnelId(v);
                              }
                            }}
                            disable={!crmName?.length}
                            orientation="wide"
                        />
                    </ProjectEditPageGridRow>
                    <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                        <CommonInput 
                            type={INPUT_TYPES.text}
                            label={t('teams.adminPage.fields.form_unisender_list_number')}
                            infoText={t('teams.adminPage.additionalFields.form_unisender_list_number_info')}
                            onWhiteBG
                            maxLength={30}
                            value={unisenderListNumber}
                            onChange={handleUnisenderListNumberChange}
                            orientation="wide"
                        />
                    </ProjectEditPageGridRow>
                    <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                        <CommonInput 
                            type={INPUT_TYPES.dropdown}
                            label={t('teams.adminPage.fields.form_send_to_unisender')}
                            options={unisenderList}
                            value={unisenderList.find(({ value }) => value === unisenderName)}
                            onChange={(item: any) => setUnisenderName(item?.value)}
                            placeholder={t('teams.adminPage.fields.form_select_unisender')}
                            orientation="wide"
                        />
                    </ProjectEditPageGridRow>
                </BorderBlock>
            )}
                {event}
                <ProjectEditPageGridRow direction={'column'} directionMobile={'column'}>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.form_fields')}
                        fixedHeight
                    />
                    <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit >
                        {(!!formFields?.length) && (
                            <>
                            {is1280 ? (
                                <>
                                    {formFields.map((button: any, index: number) => {
                                        return (
                                            <MobileButtonsWrapper directionMobile="row" gxMobile={24} offsetTopMobile={0} >
                                                {isS && (
                                                    <GridMobileNamed>
                                                        <span>{t('teams.adminPage.fields.form_button_number', { number: index + 1 })}</span>

                                                    </GridMobileNamed>
                                                )}
                                                <TeamsMobGridList cols={'1fr'}>
                                                    <FlexBox directionMobile="column">
                                                        <CommonInput 
                                                            type={INPUT_TYPES.dropdown}
                                                            label={t('teams.adminPage.fields.form_field_type')}
                                                            orientation="column"
                                                            value={{ label: getTypeName(button.type), value: button.type }}
                                                            onChange={(value: any) => handleSetFormFieldChange(index, 'type', value?.value)}
                                                            options={inputTypes() as any}  
                                                        />
                                                    </FlexBox>
                                                    {[4,8]?.includes(button.type) ? (
                                                        <FlexBox direction="column" directionMobile="column">
                                                            <FlexBox direction="column" directionMobile="column" gy={8} gyMobile={8}>
                                                                <FlexBox  directionMobile="column">
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.text}
                                                                        label={t('teams.adminPage.fields.form_field_header')}
                                                                        orientation="column"
                                                                        value={getTextByLang(button.header, i18n.language)}
                                                                        onChange={(ev: any) => handleSetFormFieldChange(index, 'header', ev.target.value, true)}
                                                                    />
                                                                </FlexBox>
                                                                <FlexBox  directionMobile="column">
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.text}
                                                                        label={t('teams.adminPage.fields.form_field_placeholder')}
                                                                        orientation="column"
                                                                        maxLength={FORM_FIELD_PLACEHOLDER_MAX_LENGTH}
                                                                        value={getTextByLang(button.placeholder, i18n.language)}
                                                                            onChange={(ev: any) => handleSetFormFieldChange(index, 'placeholder', ev.target.value, true)}
                                                                    />
                                                                   
                                                                </FlexBox>
                                                                <FlexBox direction={'column'} directionMobile="column">
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.text}
                                                                        label={t('teams.adminPage.fields.form_field_id')}
                                                                        orientation="column"
                                                                        className="id-input"
                                                                        value={button.fieldIdInCrm}
                                                                        //@ts-ignore
                                                                        onChange={(ev: any) => Utils.isNumber(ev, (val: any) => handleSetFormFieldChange(index, 'fieldIdInCrm', Number(val)))}
                                                                    />
                                                                </FlexBox>
                                                                <FlexBox  directionMobile="column">
                                                                    <CommonLabel 
                                                                        label={t('teams.adminPage.fields.form_field_required')}
                                                                    />
                                                                    <ProjectEditPageGridInput isTeamEdit isColumns>
                                                                        <MagicBoxRow 
                                                                            className="checkbox"
                                                                            checked={button.isRequired}
                                                                            label={''}
                                                                            onClick={() => handleSetFormFieldChange(index, 'isRequired', !button.isRequired)}
                                                                            isTeamEdit
                                                                            disabled={shouldSendEmailNotification}
                                                                            
                                                                        />
                                                                    </ProjectEditPageGridInput>
                                                                    <FlexBox alignMobile="end" offsetBottomMobile={10} offsetTopMobile={16}>
                                                                        <DefaultButton wh={131} whMob={107} onClick={() => handleDeleteFormFieldClick(index)}>{t('teams.adminPage.fields.form_delete')}</DefaultButton>
                                                                    </FlexBox>
                                                                </FlexBox>
                                                                <FlexBox  directionMobile="column">
                                                                    <CommonLabel 
                                                                        label={t('teams.adminPage.fields.form_field_is_tag')}
                                                                    />
                                                                    <ProjectEditPageGridInput isTeamEdit isColumns>
                                                                        <MagicBoxRow 
                                                                            className="checkbox"
                                                                            checked={button.isTagInCrm}
                                                                            label={''}
                                                                            onClick={() => handleSetFormFieldChange(index, 'isTagInCrm', !button.isTagInCrm)}
                                                                            isTeamEdit
                                                                            disabled={shouldSendEmailNotification}
                                                                            
                                                                        />
                                                                    </ProjectEditPageGridInput>
                                                                    <FlexBox alignMobile="end" offsetBottomMobile={10} offsetTopMobile={16}>
                                                                        <DefaultButton wh={131} whMob={107} onClick={() => handleDeleteFormFieldClick(index)}>{t('teams.adminPage.fields.form_delete')}</DefaultButton>
                                                                    </FlexBox>
                                                                </FlexBox>
                                                            </FlexBox>
                                                            <FlexBox direction="row" gx={16} gyMobile={16}>
                                                                <FlexBox alignMobile="end" offsetBottomMobile={10} offsetTopMobile={16}>
                                                                    <DefaultButton wh={131} whMob={107} onClick={() => handleEditDropdownInputs(button, index)}>{t('teams.adminPage.fields.form_edit')}</DefaultButton>
                                                                </FlexBox>
                                                                <FlexBox alignMobile="end" offsetBottomMobile={10} offsetTopMobile={16}>
                                                                    <DefaultButton wh={131} whMob={107} onClick={() => handleDeleteFormFieldClick(index)}>{t('teams.adminPage.fields.form_delete')}</DefaultButton>
                                                                </FlexBox>
                                                            </FlexBox>
                                                        </FlexBox>
                                                    ) : (
                                                        <>
                                                            <FlexBox  directionMobile="column">
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    label={t('teams.adminPage.fields.form_field_header')}
                                                                    orientation="column"
                                                                    value={getTextByLang(button.header, i18n.language)}
                                                                    onChange={(ev: any) => handleSetFormFieldChange(index, 'header', ev.target.value, true)}
                                                                /> 
                                                            </FlexBox>
                                                            <FlexBox  directionMobile="column">
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    label={t('teams.adminPage.fields.form_field_placeholder')}
                                                                    orientation="column"
                                                                    maxLength={FORM_FIELD_PLACEHOLDER_MAX_LENGTH}
                                                                    value={getTextByLang(button.placeholder, i18n.language)}
                                                                    onChange={(ev: any) => handleSetFormFieldChange(index, 'placeholder', ev.target.value, true)}
                                                                />      
                                                            </FlexBox>
                                                            <FlexBox  directionMobile="column">
                                                                <CommonLabel 
                                                                    label={t('teams.adminPage.fields.form_field_required')}
                                                                />
                                                                <ProjectEditPageGridInput isTeamEdit isColumns>
                                                                    <MagicBoxRow 
                                                                        className="checkbox"
                                                                        checked={button.isRequired}
                                                                        label={''}
                                                                        onClick={() => handleSetFormFieldChange(index, 'isRequired', !button.isRequired)}
                                                                        isTeamEdit
                                                                        disabled={shouldSendEmailNotification}
                                                                        hintsText={shouldSendEmailNotification && button.type === 2 ? t('teams.adminPage.additionalFields.form_field_email_required_hint') : undefined}
                                                                        positionY="top"
                                                                        
                                                                    />
                                                                </ProjectEditPageGridInput>
                                                                <FlexBox alignMobile="end" offsetBottomMobile={10} offsetTopMobile={16}>
                                                                    <DefaultButton wh={131} whMob={107} onClick={() => handleDeleteFormFieldClick(index)}>{t('teams.adminPage.fields.form_delete')}</DefaultButton>
                                                                </FlexBox>
                                                            </FlexBox>
                                                            <FlexBox  directionMobile="column">
                                                                    <CommonLabel 
                                                                        label={t('teams.adminPage.fields.form_field_is_tag')}
                                                                    />
                                                                    <ProjectEditPageGridInput isTeamEdit isColumns>
                                                                        <MagicBoxRow 
                                                                            className="checkbox"
                                                                            checked={button.isTagInCrm}
                                                                            label={''}
                                                                            onClick={() => handleSetFormFieldChange(index, 'isTagInCrm', !button.isTagInCrm)}
                                                                            isTeamEdit
                                                                            disabled={shouldSendEmailNotification}
                                                                            
                                                                        />
                                                                    </ProjectEditPageGridInput>
                                                                    <FlexBox alignMobile="end" offsetBottomMobile={10} offsetTopMobile={16}>
                                                                        <DefaultButton wh={131} whMob={107} onClick={() => handleDeleteFormFieldClick(index)}>{t('teams.adminPage.fields.form_delete')}</DefaultButton>
                                                                    </FlexBox>
                                                            </FlexBox>
                                                        </>
                                                    )}

                                                </TeamsMobGridList>

                                            </MobileButtonsWrapper>

                                        )})}
                                    </> 
                            ) : (
                                <JustTable isTeamEdit>
                                    <thead>
                                        <tr>
                                            <th style={{width: '25%'}}>{t('teams.adminPage.fields.form_field_type')}</th>
                                            <th style={{width: '20%'}}>{t('teams.adminPage.fields.form_field_header')}</th>
                                            <th style={{width: '20%'}}>{t('teams.adminPage.fields.form_field_placeholder')}</th>
                                            <th style={{width: '15%'}}>{t('teams.adminPage.fields.form_field_crm_id')}</th>
                                            <th style={{width: '10%'}}>{t('teams.adminPage.fields.form_field_required')}</th>
                                            <th style={{width: '10%'}}>{t('teams.adminPage.fields.form_field_crm_tag')}</th>
                                            <th style={{width: '10%'}}></th>
                                        </tr>
                                    </thead>
                                    {/* <TBody isFormEdit> */}
                                        <SortableList as={'tbody'} onSortEnd={onMoveOption}>
                                        {formFields.map((button: any, index: any) => {
                                            return (
                                                <SortableItem key={"dropdown-edit-sortable_" + index}>
                                                <tr>
                                                    <td>
                                                        <FlexBox direction='row' align="center" gx={16}>
                                                            <SortableKnob>
                                                                <div style={{cursor: 'grab', backgroundColor: 'transparent' }}>
                                                                    <DottedIcon />
                                                                </div>
                                                            </SortableKnob>                                                        
                                                            <CommonInput 
                                                                type={INPUT_TYPES.dropdown}
                                                                value={{ label: getTypeName(button.type), value: button.type }}
                                                                onChange={(value: any) => handleSetFormFieldChange(index, 'type', value?.value)}
                                                                options={inputTypes() as any}
                                                            />
                                                        </FlexBox>
                                                    </td>
                                                    {[8,4]?.includes(button.type) ? (
                                                        <>
                                                            <td>
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    value={getTextByLang(button.header, i18n.language)}
                                                                        onChange={(ev: any) => handleSetFormFieldChange(index, 'header', ev.target.value, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    maxLength={FORM_FIELD_PLACEHOLDER_MAX_LENGTH}
                                                                    value={getTextByLang(button.placeholder, i18n.language)}
                                                                    onChange={(ev: any) => handleSetFormFieldChange(index, 'placeholder', ev.target.value, true)}
                                                                />
                                                            </td>
                                                            <td>       
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    value={button.fieldIdInCrm}
                                                                        //@ts-ignore
                                                                    onChange={(ev: any) => Utils.isNumber(ev, (val: any) => handleSetFormFieldChange(index, 'fieldIdInCrm', Number(val)))}
                                                                />
                                                            </td>
                                                            <td style={{ width: isS ? '70px' : '150px' }}>
                                                                <FlexBox justify={'center'}>
                                                                    <MagicBoxRow
                                                                        className="checkbox"
                                                                        checked={button.isRequired}
                                                                        label={''}
                                                                        onClick={() => handleSetFormFieldChange(index, 'isRequired', !button.isRequired)}
                                                                        isTeamEdit
                                                                        
                                                                    />
                                                                </FlexBox>
                                                            </td>
                                                            <td style={{ width: isS ? '70px' : '150px' }}>
                                                                <FlexBox justify={'center'}>
                                                                    <MagicBoxRow
                                                                        className="checkbox"
                                                                        checked={button.isTagInCrm}
                                                                        label={''}
                                                                        onClick={() => handleSetFormFieldChange(index, 'isTagInCrm', !button.isTagInCrm)}
                                                                        isTeamEdit
                                                                        
                                                                    />
                                                                </FlexBox>
                                                            </td>
                                                            <td>
                                                                <FlexBox direction="row" gx={16}>
                                                                    <EditIcon24 onClick={() => handleEditDropdownInputs(button, index)}/>
                                                                    <DeleteIcon onClick={() => handleDeleteFormFieldClick(index)}/>
                                                                </FlexBox>
                                                            </td>
                                                        </>
                                                    ) : [0]?.includes(button.type) ? (
                                                        <>
                                                            <td>
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    value={getTextByLang(button.header, i18n.language)}
                                                                    onChange={(ev: any) => handleSetFormFieldChange(index, 'header', ev.target.value, true)}
                                                                />
                                                              
                                                            </td>
                                                            <td>
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    maxLength={FORM_FIELD_PLACEHOLDER_MAX_LENGTH}
                                                                    value={getTextByLang(button.placeholder, i18n.language)}
                                                                    onChange={(ev: any) => handleSetFormFieldChange(index, 'placeholder', ev.target.value, true)}
                                                                />
                                                            </td>
                                                            <td> 
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    value={button.fieldIdInCrm}
                                                                    //@ts-ignore
                                                                    onChange={(ev: any) => Utils.isNumber(ev, (val: any) => handleSetFormFieldChange(index, 'fieldIdInCrm', Number(val)))}
                                                                />
                                                            </td>
                                                            <td style={{ width: isS ? '70px' : '168px', position: 'relative' }}>
                                                                <FlexBox justify={'center'}>
                                                                    <MagicBoxRow 
                                                                        className="checkbox"
                                                                        checked={button.isRequired}
                                                                        label={''}
                                                                        onClick={() => handleSetFormFieldChange(index, 'isRequired', !button.isRequired)}
                                                                        isTeamEdit
                                                                        disabled={shouldSendEmailNotification && button.type === 2}
                                                                        hintsText={shouldSendEmailNotification && button.type === 2 ? t('teams.adminPage.additionalFields.form_field_email_required_hint') : undefined}
                                                                        positionY="top"
                                                                    />
                                                                </FlexBox>
                                                            </td>
                                                             <td style={{ width: isS ? '70px' : '168px' }}>
                                                                <FlexBox justify={'center'}>
                                                                    <MagicBoxRow
                                                                        className="checkbox"
                                                                        checked={button.isTagInCrm}
                                                                        label={''}
                                                                        onClick={() => handleSetFormFieldChange(index, 'isTagInCrm', !button.isTagInCrm)}
                                                                        isTeamEdit
                                                                        
                                                                    />
                                                                </FlexBox>
                                                            </td>
                                                            <td>
                                                                <DefaultButton disabled={shouldSendEmailNotification && button.type === 2} wh={131} whMob={107} onClick={() => handleDeleteFormFieldClick(index)}>{t('teams.adminPage.fields.form_delete')}</DefaultButton>
                                                            </td>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <td>
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    value={getTextByLang(button.header, i18n.language)}
                                                                    onChange={(ev: any) => handleSetFormFieldChange(index, 'header', ev.target.value, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    maxLength={FORM_FIELD_PLACEHOLDER_MAX_LENGTH}
                                                                    value={getTextByLang(button.placeholder, i18n.language)}
                                                                    onChange={(ev: any) => handleSetFormFieldChange(index, 'placeholder', ev.target.value, true)}
                                                                />                
                                                            </td>
                                                            <td>-</td>
                                                            <td style={{ width: isS ? '70px' : '168px', position: 'relative' }}>
                                                                <FlexBox justify={'center'}>
                                                                    <MagicBoxRow 
                                                                        className="checkbox"
                                                                        checked={button.isRequired}
                                                                        label={''}
                                                                        onClick={() => handleSetFormFieldChange(index, 'isRequired', !button.isRequired)}
                                                                        isTeamEdit
                                                                        disabled={shouldSendEmailNotification && button.type === 2}
                                                                        hintsText={shouldSendEmailNotification && button.type === 2 ? t('teams.adminPage.additionalFields.form_field_email_required_hint') : undefined}
                                                                        positionY="top"
                                                                    />
                                                                </FlexBox>
                                                            </td>
                                                             <td style={{ width: isS ? '70px' : '168px' }}>
                                                                <FlexBox justify={'center'}>
                                                                    <MagicBoxRow
                                                                        className="checkbox"
                                                                        checked={button.isTagInCrm}
                                                                        label={''}
                                                                        onClick={() => handleSetFormFieldChange(index, 'isTagInCrm', !button.isTagInCrm)}
                                                                        isTeamEdit
                                                                        
                                                                    />
                                                                </FlexBox>
                                                            </td>
                                                            <td>
                                                                <DefaultButton disabled={shouldSendEmailNotification && button.type === 2} wh={131} whMob={107} onClick={() => handleDeleteFormFieldClick(index)}>{t('teams.adminPage.fields.form_delete')}</DefaultButton>
                                                            </td>
                                                        </>
                                                    )}

                                                </tr>
                                                </SortableItem>
                                            );
                                        })}
                                        </SortableList>
                                    {/* </TBody> */}
                                </JustTable>
                            )}
                            </>
                        )}
                            <FlexBox offsetTop={24} offsetTopMobile={14}>
                                <DefaultButton wh={131} whMob={107} onClick={() => handleNewFieldClick()}>
                                    {(isS && !!formFields?.length) && <PlusSvg /> }
                                    {t('teams.adminPage.fields.form_add_field')}
                                </DefaultButton>
                            </FlexBox>
                        </ProjectEditPageGridList>
                            
                </ProjectEditPageGridRow>
            </ProjectEditPageGrid>
     
        {/*</PageViewportLayout>*/}
        </>
    );
};
import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import { FC, useEffect, useMemo, useState, useCallback, useRef } from "react";
//import { PageViewportLayout } from "shared/components/template";
import { ProjectEditPageGrid, ProjectEditPageGridLabel, ProjectEditPageGridRow } from "shared/components/ProjectEditPageGrid";
import { DatePickerTeamWrapper, ProjectEditPageGridInput, ProjectEditPageGridList } from "_deziiign/books/pages/BookEdit/styles";
import { Input } from "@brg/input";
import { Lang, Form, FormAPI, API, Endpoints, TFile } from "@brg/api";
import { useTranslation } from "react-i18next";
import { CommonInput, CommonLabel, FlexBox, GridBox, HintTooltip, INPUT_TYPES, repeat, useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { BLanguageSelectionComponent } from "core/components/BLanguageSelectionComponent";
import { SaveUserLang } from "shared/components/__ADDONS__/__LANG__/Utils/GetUserLang";
import { setAppLang } from "shared/components/__ADDONS__/__LANG__/Slice";
import { MagicBoxRow } from "shared/components/MagicBoxRow";
import { LayoutConst, useModal } from "core";
import { DefaultButton, GridMobileNamed, MobileButtonsWrapper, TBody, TeamEditLabel, TeamsMobGridList } from "../styles";
import { JustTable } from "_competition/components/style";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import {ReactComponent as PlusSvg } from "../../projectEdit/close.svg";
import { InputTypes } from "../const/InputTypes";
import { FormCheckMarkPosition, DEFAULT_CHECK_MARK_POSITION, DEFAULT_CHECK_MARK_STATE } from "../const/FormCheckMarkPosition";
import styled from "styled-components";
import EditIcon24 from "shared/icons/EditIcon24";
import DeleteIcon from "shared/icons/DeleteIcon";
import { Date24Icon } from "shared/components/tagAdminProjectsSearchBar/date24";
import { Date32Icon } from "shared/components/tagAdminProjectsSearchBar/date32";
import CopySquareIcon24 from "shared/icons/CopySquareIcon24";
import { Utils } from "shared/helpers/utils/utils";
import { useUppyLoader } from "shared/hooks/useUppyLoader";
import useUploadValidator from "shared/hooks/useUploadValidator";
import { getProjectImages } from "shared/pages/project/sections/ps-image";
import SortableList, { SortableItem, SortableKnob } from "react-easy-sort";
import { arrayMoveImmutable } from "shared/utils/arrayMove";
import { DottedIcon } from "shared/icons/DottedIcon";
import { ITeamFilterModel } from "../types";
import { cloneValue } from "../helpers/cloneValue";
import setTextByLang, { getTextByLang } from "shared/helpers/setTextByLang";
import { normalizeUrl } from "shared/helpers/normalizeUrl";
import { CustomDateTimePicker } from "_competition/pages/CreateCompetitionPage/stylesEdit";
import { TeamAdminEditType } from "../types/types";
import { AdminEmailsToReceiveDataField } from "./AdminEmailsToReceiveDataField";

const Title = styled.h2`
    margin: 0 0 20px 0;
    font-size: 22px;
    font-weight: 600;
    color: #151514;
`;

const CopyIcon = styled.div`
     cursor: pointer;
`
const BorderBlock = styled(FlexBox)`
    padding: 24px;
    border: 1px solid #CDCDCD;
`

const CRM_ID_REG = /^[A-Za-zА-Яа-я]$/;

    const crmList = [
        {
            label: 'CRM design.hse.ru',
            value: 'designhse'
        }, 
        {
            label: 'CRM deziiign',
            value: 'burgundyproject1'
        },
        {
            label: 'CRM designkids.hse',
            value: 'unikhse'
        }
    ]

    const unisenderList = [
        {
            label: 'design.hse.ru',
            value: 'designhse'
        }, 
        {
            label: 'deziiign',
            value: 'burgundyproject1'
        },
        {
            label: 'designkids.hse',
            value: 'unikhse'
        }
    ]

export interface ITeamTab {
    path: string;
    name: LangObject[];
    about: LangObject[];
    filter: ITeamFilterModel;
    isMain: boolean;
}

type TeamFormsEditPropsT = {
    form: any;
    onUpdate: (val: any) => void;
    onClose?: () => void;
    editType?: TeamAdminEditType;
    onStatusSet: (val: string) => void;
    isChangesSaved?: boolean;
    setIsChangesSaved?: (value: boolean) => void;
    setIsFormFieldsFilled: (value: boolean) => void;
    canShowCrm?: boolean;
}

interface LocalizedText {
  lang: 'ru' | 'en';
  name: string;
}

interface FormField {
  type: number; 
  header: LocalizedText[];
  placeholder: LocalizedText[];
  isRequired: boolean;
  inlineVariants: unknown[];
  fieldIdInCrm: number | null;
  isTagInCrm?: boolean; 
}

const NEW_FIELD = { type: 0, header: createDefaultLangObject(''), placeholder: createDefaultLangObject(''), isRequired: true, isTagInCrm: false }

const FORM_FIELD_PLACEHOLDER_MAX_LENGTH = 60

const initialObject = [
    {
        "lang": "Ru",
        "name": ""
    },
    {
        "lang": "En",
        "name": ""
    }
]
const defaultNotificationSubject = [
    {
        "lang": "Ru",
        "name": "Ваше сообщение успешно получено"
    },
    {
        "lang": "En",
        "name": "Your message has been successfully received"
    }
]
const defaultNotificationText = [
    {
        "lang": "Ru",
        "name": "Спасибо, что поделились информацией. Мы ценим вашу вовлечённость и обязательно ознакомимся с вашим сообщением."
    },
    {
        "lang": "En",
        "name": "Thank you for sharing the information. We appreciate your involvement and will definitely review your message."
    }
]

const FormImageWrapper = styled(FlexBox)`
    position: relative;
    width: 100%;
`;

const FormImageId = styled.div`
    padding: 12px; 
    border-radius: 3px; 
    background-color: #F2F2F2;
    font-size: 13px;
    color: #151514;
    width: 100%;
    position: relative;
`;

const FormImageInput = styled.input`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 1;
    cursor: pointer;
`;

const LangRowLeadingSpacer = styled.div`
    min-width: 224px;
    margin-right: 16px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        min-width: 160px;
    }
`;

export const TeamFormsEdit: FC<TeamFormsEditPropsT> = (props) => {
    const { t, i18n } = useTranslation();
    const isMobile = useIsMobile();
    const modal = useModal();
    const toasts = useToasts();
    const is1280 = useBreakpoint(LayoutConst.screen.l_12);
    const isS = useBreakpoint(LayoutConst.screen.s);
    const [techName, setTechName] = useState<string>('');
    const [formAddress, setFormAddress] = useState<string>('');
    const [description, setDescription] = useState<LangObject[]>([]);
    const [header, setHeader] = useState<LangObject[]>([]);
    const [textOnComplete, setTextOnComplete] = useState<LangObject[]>([]);
    const [ppdWithCheckMark, setPpdWithCheckMark] = useState<LangObject[][]>([initialObject]);
    const [ppdCheckMarkPosition, setPpdCheckMarkPosition] = useState<FormCheckMarkPosition>(DEFAULT_CHECK_MARK_POSITION);
    const [ppdCheckMarkDefaultState, setPpdCheckMarkDefaultState] = useState<boolean>(DEFAULT_CHECK_MARK_STATE);
    const [textSubmitButton, setTextOnSubmitBtn] = useState<LangObject[]>([]);
    const [funnelId, setFunnelId] = useState('');
    const [unisenderListNumber, setUnisenderListNumber] = useState('');
    const [eventTheme, setEventTheme] = useState('');
    const [eventDate, setEventDate] = useState<Date | null>(null);
    const [eventTime, setEventTime] = useState('');
    const [eventFormat, setEventFormat] = useState('');
    const [eventPlace, setEventPlace] = useState('');
    const [price, setPrice] = useState('');
    const [pndFields, setPndFiels] = useState<LangObject[]>([]);
    const [emailNotificationSubject, setEmailNotificationSubject] = useState<LangObject[]>([]);
    const [emailNotificationText, setEmailNotificationText] = useState<LangObject[]>([]);
    const [emailSenderName, setEmailSenderName] = useState<string>('');
    const [adminEmailsToReceiveData, setAdminEmailsToReceiveData] = useState<string[]>([]);
    const [formFields, setFormFields] = useState<any>([]);
    const [crmName, setCrmName] = useState('');
    const [unisenderName, setUnisenderName] = useState('');
    const [registrationRequestLimit, setRegistrationRequestLimit] = useState<number | ''>('');
    const [isRegistrationRequestLimitVisible, setIsRegistrationRequestLimitVisible] = useState<boolean>(false);
    const [successButtonTitle, setSuccessButtonTitle] = useState<LangObject[]>([]);
    const [successButtonLink, setSuccessButtonLink] = useState<string>('');
    const { form, isChangesSaved, onUpdate, onStatusSet, setIsFormFieldsFilled, setIsChangesSaved, onClose, editType, canShowCrm = false } = props;
    const [sendingEmail, setSendingEmail] = useState('');
    const [shouldSendEmailNotification, setShouldSendEmailNotification] = useState(false);
    const [isRegisteredUsersOnly, setIsRegisteredUsersOnly] = useState(true);
    const [isFastRegisterWithEmail, setIsFastRegisterWithEmail] = useState(false);
    const [isProductPlatformForm, setIsProductPlatformForm] = useState(false);
    const [formTags, setFormTags] = useState([])
    
    const [priorPage, setPriorPage] = useState({
        title: [] as LangObject[],
        description: [] as LangObject[],
        buttonText: [] as LangObject[]
    });
    
    const [sortedData, setSortedData] = useState([]);
    const [priorPageImages, setPriorPageImages] = useState([]);
    const [time, setTime] = useState(Date.now());
    const [priorTime, setPriorTime] = useState(Date.now());
    const [files, setFiles] = useState([]);
    const [priorFiles, setPriorFiles] = useState([]);
    const fileRef = useRef<HTMLInputElement>(null);
    const priorFileRef = useRef<HTMLInputElement>(null);
    const validator = useUploadValidator(false, false);
    const images = getProjectImages(form, i18n.language) || [];
  
    

    const onUploadComplete = useCallback((uploadComplete: any) => {
        if (uploadComplete) {
            setFiles([]);
        }
    }, []);

    const [uppy, data] = useUppyLoader(files, fileRef, onUploadComplete, time);
    const [priorUppy, priorData] = useUppyLoader(priorFiles, priorFileRef, onUploadComplete, priorTime);

    useEffect(() => {
        if (data?.length > 0) {
            setSortedData(data);
        }
    }, [data]);

    useEffect(() => {
        if (priorData?.length > 0) {
            setPriorPageImages(priorData);
        }
    }, [priorData]);

    const onRemoveImage = useCallback((id: string, name: string) => {
        if (fileRef?.current) {
            fileRef.current.value = '';
        }
        uppy.removeFile(id);
        setTime(Date.now());
        setSortedData([]);
        setFiles([]);
    }, [fileRef, uppy]);

    const validateImageDimensions = (file: TFile): Promise<boolean> => {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                const isValid = img.height <= 200;
                resolve(isValid);
            };
            img.onerror = () => resolve(false);
            img.src = URL.createObjectURL(file);
        });
    };

    const onAddImage = useCallback(async (e: any) => {
        const newFiles = Array.from(e.target.files) as TFile[];

        if (fileRef?.current) {
            fileRef.current.value = '';
        }

        setTime(Date.now());

        let multipleFilesCheckResult: any = [];
        if (newFiles?.length > 0) {
            multipleFilesCheckResult = await Promise.all(
                newFiles.map(async (img: TFile) => {
                    const isValidFile = await validator([img]);
                    const isValidDimensions = await validateImageDimensions(img);
                    return isValidFile && isValidDimensions;
                })
            );
        }
        const allowed = await validator(files);

        if (!allowed || multipleFilesCheckResult?.includes(false)) {
            e.target.value = '';
            if (multipleFilesCheckResult?.includes(false)) {
                toasts.error(t('teams.adminPage.additionalFields.form_image_height_error'));
            }
            return;
        }

        if (files?.length > 0) {
            setFiles([]);
        }
        setSortedData([]);

        setTimeout(() => {
            setFiles(newFiles);
        }, 0);
    }, [files, fileRef, validator, onRemoveImage, toasts]);

    const handleRemoveFormImage = useCallback(() => {
        if (sortedData?.length > 0) {
            onRemoveImage(sortedData[0].id, sortedData[0].name);
        }
    }, [sortedData, onRemoveImage]);

    const onRemovePriorImage = useCallback((id: string, name: string) => {
        if (priorFileRef?.current) {
            priorFileRef.current.value = '';
        }
        priorUppy.removeFile(id);
        setPriorTime(Date.now());
        setPriorPageImages([]);
        setPriorFiles([]);
    }, [priorFileRef, priorUppy]);

    const onAddPriorImage = useCallback(async (e: any) => {
        const newFiles = Array.from(e.target.files) as TFile[];

        if (priorFileRef?.current) {
            priorFileRef.current.value = '';
        }

        setPriorTime(Date.now());

        let multipleFilesCheckResult: any = [];
        if (newFiles?.length > 0) {
            multipleFilesCheckResult = await Promise.all(
                newFiles.map(async (img: TFile) => {
                    return await validator([img]);
                })
            );
        }
        const allowed = await validator(priorFiles);

        if (!allowed || multipleFilesCheckResult?.includes(false)) {
            e.target.value = '';
            return;
        }

        if (priorFiles?.length > 0) {
            setPriorFiles([]);
        }
        setPriorPageImages([]);

        setTimeout(() => {
            setPriorFiles(newFiles);
        }, 0);
    }, [priorFiles, priorFileRef, validator]);

    const handleRemovePriorImage = useCallback(() => {
        if (priorPageImages?.length > 0) {
            onRemovePriorImage(priorPageImages[0].id, priorPageImages[0].name);
        }
    }, [priorPageImages, onRemovePriorImage]);
    
    useEffect(() => {
                API.request()
                    .endpoint(Endpoints.geoGateway)
                    .url(`/api/Forms/form-tags`)
                    .get()
                    .send()
                    .then((r: any) => r.json())
                    .then((r: any) => {
                        setFormTags(r);
                    }).catch((e: any) => {
                    console.log(e)
                })
        }, [])

    const inputTypes = (): { label: string, value: number }[] => {
        
        //@ts-ignore
        return Object.keys(InputTypes)
        ?.map((type, idx) => ({ label: t(`teams.adminPage.fields.inputs_types.${type.toLowerCase()}`), value: idx }))
        ?.filter((type, idx) => [0,1,2,3,4,6,8,9,10].includes(idx))
        ?.sort((a,b) => b.value === 1? 1 : b.value === 7 ? 0 : -1)
    }

    const getTypeName = (type: number): string => inputTypes()?.find((item) => item.value === type)?.label || '';

    const handleNewFieldClick = () => {
        setFormFields((prev: any[]) => [...(prev || []), { ...NEW_FIELD }])
    }

    const handleSetFormFieldChange = (idx: number, field: string, value: string | boolean, isLang?: boolean) => {
        const newList = formFields;
        setFormFields(newList.map((form: any, index: number, arr: any[]) => {
            if (index === idx) {
                return isLang ? {
                        ...form, 
                        //@ts-ignore
                        [field]: setTextByLang(arr[idx]?.[field], i18n.language, value) 
                    } : {
                        ...form, 
                        [field]: value 
                    }
            }
            return form
        }))
    }

    const handleEditDropdownInputs = (field: any, parentIdx: number) => {

        const handleSetDropdownVariants = (data: any, index: number) => {
            setFormFields((prev: any[]) => prev.map((item: any, i: number) => i === index ? data : item))
        }
        modal.show('form-dropdown-edit', {
            onAdd: (data: any, parentIdx: number) => handleSetDropdownVariants(data, parentIdx),
            parentIdx,
            field
        })
    }


    const handleDeleteFormFieldClick = (idx: number) => {
        setFormFields(formFields.filter((form: any, index: number) =>  index !== idx));
    }
    
    useEffect(() => {
        if (form) {
            const {
                title = '',
                description = '',
                buttonText = '',
                titleImages = []
                } = form?.priorPage || {};
            const textSubmitButton = form.textSubmitButton.some(
              (textSubmitButton: { name: string; lang: string }) =>
                textSubmitButton.name
            )
              ? form.textSubmitButton
              : [
                  { lang: "ru", name: "Отправить" },
                  { lang: "en", name: "Send" },
                ];
            setTechName(form.techName)
            if (form.formId && form.teamId) {
                setFormAddress(`${window.location.origin}/teams/form/${form.formId}`)
            } else {
                setFormAddress('')
            }
            setDescription(form.description ?? [])
            setHeader(form.header ?? [])
            setTextOnComplete(form.textOnComplete)
            setPpdWithCheckMark(form.ppdWithCheckMark || [initialObject]);
            //@ts-ignore
            setPpdCheckMarkPosition(form.ppdCheckMarkPosition ?? DEFAULT_CHECK_MARK_POSITION);
            //@ts-ignore
            setPpdCheckMarkDefaultState(form.ppdCheckMarkDefaultState ?? DEFAULT_CHECK_MARK_STATE);
            setIsRegisteredUsersOnly(form.isRegisteredUsersOnly)
            //@ts-ignore
            setIsFastRegisterWithEmail(form.IsFastRegisterWithEmail === true || form.isFastRegisterWithEmail === true)
            setShouldSendEmailNotification(form.shouldSendEmailNotification)
            setIsProductPlatformForm(form.isProductPlatformForm || false)
            setEmailNotificationSubject(form.emailNotificationSubject || initialObject)
            setEmailNotificationText(form.emailNotificationText || initialObject)
            setEmailSenderName(form.emailSenderName || '')
            //@ts-ignore
            setAdminEmailsToReceiveData(form.adminEmailsToReceiveData || [])
            setTextOnSubmitBtn(textSubmitButton)
            setPndFiels(form.pndFields?.[0]?.value || [])
            setFormFields(form.formFields);
            setCrmName(form?.crmName || '');
            setUnisenderName(form?.unisenderName || '');
            setUnisenderListNumber(form?.unisenderListNumber || '');
            setRegistrationRequestLimit(form?.registrationRequestLimit || '');
            setIsRegistrationRequestLimitVisible(form?.isRegistrationRequestLimitVisible || false);
            setEventTheme(form?.formEvent?.theme || '');
            setEventDate(form?.formEvent?.date ? new Date(form.formEvent.date) : null);
            setEventTime(form?.formEvent?.time || '');
            setEventFormat(form?.formEvent?.format || '');
            setEventPlace(form?.formEvent?.place || '');
            setPrice(form?.price || '');
            setSuccessButtonTitle(form?.successButtonTitle || []);
            setSuccessButtonLink(form?.successButtonLink || '');
            setFunnelId(
                form?.integration?.funnelId === 0 
                ? '' 
                : form?.integration?.funnelId)
            
            setPriorPage({
                title: title || [],
                description: description || [],
                buttonText: buttonText || []
            });
            
            if (form?.titleImages?.length && images) {
                const cleanFileId = images?.[0]?.fileId?.replace('_orig', '');
                const mockFile = {
                        id: cleanFileId,
                        name: t('teams.adminPage.fields.form_existing_image'),
                        src: images?.[0]?.url 
                    };
                    
                    setSortedData([mockFile]);
            } else {
                setSortedData([]);
            }

            if (titleImages?.length) {
                const cleanFileId = titleImages?.[0]?.fileId?.replace('_orig', '');
                const mockFile = {
                    id: cleanFileId,
                    name: t('teams.adminPage.fields.form_prior_page_image'),
                    src: titleImages?.[0]?.url
                };
                setPriorPageImages([mockFile]);
            } else {
                setPriorPageImages([]);
            }
        }
            } , [form?.formId])
        useEffect(() => {
            const requiredEmailNotification =  shouldSendEmailNotification
              ? !!Lang(emailNotificationText, i18n.language) &&
                  !!Lang(emailNotificationSubject, i18n.language)
              : true
            
            const requiredPriorPageFields = isRegisteredUsersOnly
              ? !!Lang(priorPage.title, i18n.language) &&
                !!Lang(priorPage.description, i18n.language) &&
                !!priorPageImages?.length &&
                !!Lang(priorPage.buttonText, i18n.language)
              : true
              
          setIsFormFieldsFilled(
            !!techName &&
              !!Lang(header, i18n.language) &&
              !!Lang(textOnComplete, i18n.language) &&
              !!Lang(textSubmitButton, i18n.language) &&
             requiredEmailNotification &&
             requiredPriorPageFields
          );
        }, [
          techName,
          header,
          textOnComplete,
          textSubmitButton,
          shouldSendEmailNotification,
          emailNotificationText,
          emailNotificationSubject,
          isRegisteredUsersOnly,
          priorPage.title,
          priorPage.description,
          priorPage.buttonText,
          priorPageImages,
        ]);
        
    // console.log('sortedData', sortedData);
    const isEmpty = (langObj: LangObject[]): boolean => {
        return langObj?.every((i) => i?.name === '') || !emailNotificationSubject?.length;
    }
    const handleDateChange = (value: Date | null) => {
        setEventDate(value);
    };
    const handleBlur = useCallback(() => {
        const minDate = new Date();

        if (eventDate && eventDate < minDate) {
            handleDateChange(minDate)
        }
    }, [eventDate]);

    const handleUnisenderListNumberChange = useCallback((ev: any) => {
        const sanitized = ev.target.value
            .replace(/[^\d,]/g, '')
            .replace(/,{2,}/g, ',');
        setUnisenderListNumber(sanitized);
    }, []);

    useEffect(() => {
        if (form && form.formId && isChangesSaved) {
            if (form && form.formId) {
                onStatusSet(t('saving'));
          
                const copy: Form<'Global'> = { ...form};
                //@ts-ignore
                copy.techName = techName;
                //@ts-ignore
                copy.formAddress = formAddress;
                copy.description = cloneValue(description);
                copy.header = cloneValue(header);
                copy.textOnComplete = cloneValue(textOnComplete);
                //@ts-ignore
                copy.ppdWithCheckMark = ppdWithCheckMark.map(field => cloneValue(field));
                //@ts-ignore
                copy.ppdCheckMarkPosition = ppdCheckMarkPosition;
                //@ts-ignore
                copy.ppdCheckMarkDefaultState = ppdCheckMarkDefaultState;
                //@ts-ignore
                copy.isRegisteredUsersOnly = isRegisteredUsersOnly;
                //@ts-ignore
                copy.IsFastRegisterWithEmail = isFastRegisterWithEmail;
                //@ts-ignore
                copy.shouldSendEmailNotification = shouldSendEmailNotification;
                //@ts-ignore
                copy.isProductPlatformForm = isProductPlatformForm;
                 //@ts-ignore
                copy.emailNotificationSubject = isEmpty(emailNotificationSubject) ? defaultNotificationSubject : cloneValue(emailNotificationSubject);
                //@ts-ignore
                copy.emailNotificationText = isEmpty(emailNotificationText) ? defaultNotificationText : cloneValue(emailNotificationText);
                //@ts-ignore
                copy.emailSenderName = emailSenderName;
                //@ts-ignore
                copy.adminEmailsToReceiveData = adminEmailsToReceiveData;
                copy.textSubmitButton = cloneValue(textSubmitButton);
                copy.pndFields = [ { name: [...cloneValue(pndFields)], value: [...cloneValue(pndFields)] } ]
                //@ts-ignore
                copy.formFields = formFields;
                //@ts-ignore
                copy.successButtonTitle = cloneValue(successButtonTitle);
                //@ts-ignore
                copy.successButtonLink = successButtonLink;
                //@ts-ignore
                copy.price = Number(price);
                //@ts-ignore
                copy.unisenderListNumber = unisenderListNumber.trim().replace(/^,+|,+$/g, '');
                //@ts-ignore
                copy.unisenderName = !!unisenderName?.length ? unisenderName : '';
                 //@ts-ignore
                copy.formEvent = {
                    theme: eventTheme,
                    date: eventDate,
                    time: eventTime,
                    format: eventFormat,
                    place: eventPlace
                };
                //@ts-ignore
                copy.crmName = !!crmName?.length ? crmName : ''
                //@ts-ignore
                copy.registrationRequestLimit = registrationRequestLimit || null;
                //@ts-ignore
                copy.isRegistrationRequestLimitVisible = isRegistrationRequestLimitVisible;
                //@ts-ignore
                copy.priorPage = {
                    title: cloneValue(priorPage.title),
                    description: cloneValue(priorPage.description),
                    buttonText: cloneValue(priorPage.buttonText),
                };

                if (sendingEmail?.length) {
                    //@ts-ignore
                    copy.emailOptions = {
                        shouldNotify: true,
                        letterText: sendingEmail
                    }
                }
                
                if (sortedData?.length > 0) {
                    const cleanFileId = images?.[0]?.fileId?.replace('_orig', '');
                    const sameImage = sortedData[0].id === cleanFileId
                    //@ts-ignore
                    copy.headerImage = sameImage ? null : sortedData[0]?.id;
                }

                if (priorPageImages?.length > 0) {
                    //@ts-ignore
                    copy.priorPage.titleImage = priorPageImages[0]?.id;
                }
                
                copy.integration = { 
                    ...form?.integration, 
                    ...(!!funnelId?.length ? { funnelId: Number(funnelId) } : {}),
                }

                FormAPI.Update(copy).then((r) => {
                    setTimeout(() => onStatusSet(t('editing_saved')), 1000)
                    onUpdate(Date.now())
                    onClose?.()
                })

            } 
        }

    }, [description, header, textOnComplete, ppdWithCheckMark, ppdCheckMarkPosition, ppdCheckMarkDefaultState, isRegisteredUsersOnly, isFastRegisterWithEmail, shouldSendEmailNotification, isProductPlatformForm, emailNotificationSubject, emailNotificationText, emailSenderName, adminEmailsToReceiveData, formFields, pndFields, techName, formAddress, textSubmitButton, funnelId, unisenderListNumber, unisenderName, registrationRequestLimit, isRegistrationRequestLimitVisible, isChangesSaved, sortedData, priorPage, priorPageImages, successButtonTitle, successButtonLink]);
    
     const registeredUsersOnly = useMemo(() => {
    
            return (
                <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.registed_user_only')}
                        infoText={t('teams.adminPage.additionalFields.registed_user_only_msg')}
                        onWhiteBG
                        fixedHeight
                    />
                    <ProjectEditPageGridInput isTeamEdit isCheckbox>
                        <MagicBoxRow
                            className={'checkbox'}
                            checked={isRegisteredUsersOnly}
                            label={''}
                            onClick={() => {
                                const newValue = !isRegisteredUsersOnly;
                                setIsRegisteredUsersOnly(newValue);
                                // При включении "только для зарегистрированных" отключаем быструю регистрацию
                                if (newValue) {
                                    setIsFastRegisterWithEmail(false);
                                }
                            }}
                            isTeamEdit
                        />
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>
            )
        }, [isRegisteredUsersOnly, isS, t])

     const fastRegisterWithEmail = useMemo(() => {
            // Показываем только когда отключен чекбокс "Заполнение формы только авторизованным пользователям"
            if (isRegisteredUsersOnly) {
                return null;
            }

            return (
                <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.fast_register_with_email')}
                        infoText={t('teams.adminPage.additionalFields.fast_register_with_email_msg')}
                        onWhiteBG
                        fixedHeight
                    />
                    <ProjectEditPageGridInput isTeamEdit isCheckbox>
                        <MagicBoxRow
                            className={'checkbox'}
                            checked={isFastRegisterWithEmail}
                            label={''}
                            onClick={() => {
                                const newValue = !isFastRegisterWithEmail;
                                
                                if (newValue) {
                                    const emailFieldExists = formFields.some((field: FormField) => {
                                        return field.type === 2
                                    });
                                    
                                    if (!emailFieldExists) {
                                        const newEmailField = {
                                            type: 2,
                                            header: [
                                                { lang: "ru", name: "Почта" },
                                                { lang: "en", name: "" }
                                            ],
                                            placeholder: [
                                                { lang: "Ru", name: "" },
                                                { lang: "En", name: "" }
                                            ],
                                            isRequired: true,
                                            isTagInCrm : false,
                                            inlineVariants: [],
                                            fieldIdInCrm: null,
                                        };                                       
                                        setFormFields([...formFields, newEmailField]);
                                    }
                                }
                        
                                setIsFastRegisterWithEmail(newValue);
                            }}
                            isTeamEdit
                        />
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>
            )
        }, [isFastRegisterWithEmail, isRegisteredUsersOnly, formFields, isS, t])

     const iSSendEmailNotification = useMemo(() => {
    
            return (
                <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.email_notification')}
                        infoText={t('teams.adminPage.additionalFields.send_email_msg')}
                        onWhiteBG
                        fixedHeight
                    />
                    <ProjectEditPageGridInput isTeamEdit isCheckbox>
                        <MagicBoxRow
                            className={'checkbox'}
                            checked={shouldSendEmailNotification}
                            label={''}
                            onClick={() => {
                                const newValue = !shouldSendEmailNotification;
                                
                                if (newValue) {
                                    // Добавляем email-поле, если его нет
                                    const emailFieldExists = formFields.some((field: FormField) => {
                                        
                                        return field.type === 2
                                    });
                                    if (!emailFieldExists) {
                                        const newEmailField = {
                                            type: 2,
                                            header: [
                                                { lang: "ru", name: "Почта" },
                                                { lang: "en", name: "" }
                                            ],
                                            placeholder: [
                                                { lang: "Ru", name: "" },
                                                { lang: "En", name: "" }
                                            ],
                                            isRequired: true,
                                            isTagInCrm : false,
                                            inlineVariants: [],
                                            fieldIdInCrm: null,
                                        };                                       
                                        setFormFields([...formFields, newEmailField]);
                                    }
                                }
                        
                                setShouldSendEmailNotification(newValue);
                            }}
                            isTeamEdit
                        />
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>
            )
        }, [shouldSendEmailNotification, formFields, isS, t])

    const isProductPlatformFormField = useMemo(() => {
        return (
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.product_platform_form')}
                    infoText={t('teams.adminPage.additionalFields.product_platform_form_msg')}
                    onWhiteBG
                    fixedHeight
                />
                <ProjectEditPageGridInput isTeamEdit isCheckbox>
                    <MagicBoxRow
                        className={'checkbox'}
                        checked={isProductPlatformForm}
                        label={''}
                        onClick={() => setIsProductPlatformForm(!isProductPlatformForm)}
                        isTeamEdit
                    />
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
        )
    }, [isProductPlatformForm, isS, t])

    const event = useMemo(() => {

            return (
                <>
                <BorderBlock offsetTop={24} direction="column">
                    <CommonLabel 
                        label={t('teams.adminPage.fields.event')}
                        infoText={t('teams.adminPage.additionalFields.event_msg')}
                        fixedHeight
                        onWhiteBG
                    />
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        orientation="wide"
                        label={t('teams.adminPage.fields.event_price')}
                        value={price}
                        infoText={t('teams.adminPage.additionalFields.price_msg')}
                        onWhiteBG
                        onChange={(ev: any) => {
                            const value = ev.target.value;
                            if (value === '' || /^[0-9]+$/.test(value)) {
                                setPrice(value);
                            }
                        }}
                    />
                </ProjectEditPageGridRow>
                <FlexBox wrap="wrap" justify="space-between">
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.event_theme')}
                        orientation="wide"
                        value={eventTheme}
                        onChange={(ev: any) => setEventTheme(ev.target.value)}
                    />
                </ProjectEditPageGridRow>
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.event_format')}
                        orientation="wide"
                        value={eventFormat}
                        onChange={(ev: any) => setEventFormat(ev.target.value)}
                    />
                </ProjectEditPageGridRow>
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.event_date')}
                        fixedHeight
                    />
                    <DatePickerTeamWrapper formEdit>
                         <CustomDateTimePicker
                            value={eventDate || undefined}
                            className="date-input"
                            calendarIcon={isMobile ? <Date24Icon />  : <Date32Icon />}
                            clearIcon={null}
                            format="dd-MM-yyyy"
                            minDate={new Date()}
                            // maxDate={addYears(new Date(), 5)}
                            locale={i18n.language}
                            onChange={handleDateChange}
                            onCalendarClose={handleBlur}
                            isFormPage
                            />
                    </DatePickerTeamWrapper>
                </ProjectEditPageGridRow>
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.event_time')}
                        fixedHeight
                    />
                    <ProjectEditPageGridInput>
                        <Input.Text
                            type="time"
                            value={eventTime}
                            onChange={(ev: any) => setEventTime(ev.target.value)}
                        />
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>
                
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.event_place')}
                        orientation="wide"
                        value={eventPlace}
                        onChange={(ev: any) => setEventPlace(ev.target.value)}
                    />
                </ProjectEditPageGridRow>
                </FlexBox>
                </BorderBlock>
                </>
            )
        }, [eventDate, eventFormat, eventPlace, eventTheme, price, eventTime, handleBlur, i18n.language, isMobile])

    const previewPageFields = useMemo(() => {
        return(
            <>
            <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.prior_page_title')}
                        maxLength={100}
                        value={Lang(priorPage.title, i18n.language)}
                        onChange={(ev: any) => setPriorPage({
                            ...priorPage,
                            title: setTextByLang(priorPage.title, i18n.language, ev.target.value)
                        })}
                        orientation="wide"
                        required
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.textarea}
                        label={t('teams.adminPage.fields.prior_page_description')}
                        maxLength={500}
                        className="form-textarea"
                        value={getTextByLang(priorPage.description, i18n.language)}
                        onChange={(ev: any) => setPriorPage({
                            ...priorPage,
                            description: setTextByLang(priorPage.description, i18n.language, ev.target.value)
                        })}
                        orientation="wide"
                        required
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.prior_page_image')}
                        infoText={t('teams.adminPage.additionalFields.prior_page_image_info')}
                        onWhiteBG
                        fixedHeight
                        required
                    />
                    <ProjectEditPageGridInput>
                        <FormImageWrapper  gx={8} align="center">
                            {priorPageImages?.length > 0 ? (
                                <>
                                    <FormImageId>
                                        {priorPageImages[0]?.name || t('teams.adminPage.fields.form_file_not_selected')}
                                        <FormImageInput
                                            ref={priorFileRef}
                                            type="file"
                                            accept="image/jpeg, image/gif, image/png"
                                            onChange={onAddPriorImage}
                                        />
                                    </FormImageId>
                                    <FlexBox gx={8}>
                                        <DefaultButton 
                                            wh={131} 
                                            whMob={107} 
                                            onClick={() => priorFileRef.current?.click()}
                                        >
                                            {t('teams.adminPage.fields.form_change')}
                                        </DefaultButton>
                                        <DefaultButton 
                                            wh={131} 
                                            whMob={107} 
                                            onClick={handleRemovePriorImage}
                                            style={{ backgroundColor: '#FF4444', color: 'white' }}
                                        >
                                            {t('teams.adminPage.fields.form_delete')}
                                        </DefaultButton>
                                    </FlexBox>
                                </>
                            ) : (
                                <>
                                    <DefaultButton 
                                        wh={131} 
                                        whMob={107} 
                                        onClick={() => priorFileRef.current?.click()}
                                    >
                                        {t('teams.adminPage.fields.form_add')}
                                    </DefaultButton>
                                    <FormImageInput
                                        ref={priorFileRef}
                                        type="file"
                                        accept="image/jpeg, image/gif, image/png"
                                        onChange={onAddPriorImage}
                                    />
                                </>
                            )}
                        </FormImageWrapper>
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.prior_page_button_title')}
                        maxLength={50}
                        value={getTextByLang(priorPage.buttonText, i18n.language)}
                        onChange={(ev: any) => setPriorPage({
                            ...priorPage,
                            buttonText: setTextByLang(priorPage.buttonText, i18n.language, ev.target.value)
                        })}
                        orientation="wide"
                        required
                    />
                </ProjectEditPageGridRow>
                </>
        )
    }, [priorPage, priorPageImages])
        
    const handleAddPpdField = () => {
        if (ppdWithCheckMark.length < 3) {
            setPpdWithCheckMark([...ppdWithCheckMark, initialObject]);
        }
    };

    const handleRemovePpdField = (index: number) => {
        if (ppdWithCheckMark.length > 1) {
            setPpdWithCheckMark(ppdWithCheckMark.filter((_, i) => i !== index));
        }
    };

    const handlePpdFieldChange = (index: number, value: string) => {
        const newPpdFields = [...ppdWithCheckMark];
        newPpdFields[index] = setTextByLang(newPpdFields[index], i18n.language, value);
        setPpdWithCheckMark(newPpdFields);
    };

    const handleCopyFormAddress = () => {
        if (formAddress) {
            navigator.clipboard.writeText(formAddress).then(() => {
                toasts.info(t('link_copied'));
            });
        }
    };
     const handlePathBlur = useCallback(() => {
        if (!successButtonLink) return;

        const normalizedUrl = normalizeUrl(successButtonLink);
        
        if (normalizedUrl !== successButtonLink) {
            setSuccessButtonLink(normalizedUrl);
        }
    }, [successButtonLink]);

    const onMoveOption = useCallback((oldIndex: number, newIndex: number) => {
        const newOpt = arrayMoveImmutable(formFields, oldIndex, newIndex)
        setFormFields(newOpt);
    } , [formFields])
    
    return (
        <>
        {/*<PageViewportLayout offsetTop={40}>*/}
            
            <ProjectEditPageGrid isTeamPage offsetBottom={80}>
                
                {editType !== TeamAdminEditType.SIMPLY && (
                    <Title>
                        {t('teams.adminPage.additionalFields.form_title')}
                    </Title>
                )}

                <ProjectEditPageGridRow isTeamEdit style={{flexDirection: 'row'}}>
                    {!isS && <LangRowLeadingSpacer />}
                    <FlexBox width={'100%'}  widthMobile={isS ? '100%' : '558px'} style={{ maxWidth: isS ? '100%' : '600px' }} >
                        <BLanguageSelectionComponent
                            isProjectPage={true}
                            onLangSelect={(lang) => {
                                SaveUserLang(lang as 'en' | 'ru');
                                setAppLang(lang);
                                i18n.changeLanguage(lang);
                            }}
                            key={'lang'}
                            fs={true}
                        />
                    </FlexBox>
                </ProjectEditPageGridRow>         
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.form_name')}
                        maxLength={50}
                        value={techName}
                        onChange={(ev: any) => setTechName(ev.target.value)}
                        orientation="wide"
                        required
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.form_header')}
                        maxLength={200}
                        value={getTextByLang(header, i18n.language)}
                        onChange={(ev: any) => setHeader(setTextByLang(header, i18n.language, ev.target.value))}
                        orientation="wide"
                        required
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.textarea}
                        label={t('teams.adminPage.fields.form_text')}
                        maxLength={800}
                        className="form-textarea"
                        value={getTextByLang(description, i18n.language)}
                        onChange={(ev: any) => setDescription(setTextByLang(description, i18n.language, ev.target.value))}
                        orientation="wide"
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.form_image')}
                        infoText={t('teams.adminPage.additionalFields.form_image_info')}
                        onWhiteBG
                        fixedHeight
                    />
                    <ProjectEditPageGridInput>
                        <FormImageWrapper  gx={8} align="center">
                            {sortedData?.length > 0 ? (
                                <>
                                    <FormImageId>
                                        {sortedData[0]?.name || t('teams.adminPage.fields.form_file_not_selected')}
                                        <FormImageInput
                                            ref={fileRef}
                                            type="file"
                                            accept="image/jpeg, image/gif, image/png"
                                            onChange={onAddImage}
                                        />
                                    </FormImageId>
                                    <FlexBox gx={8}>
                                        <DefaultButton 
                                            wh={131} 
                                            whMob={107} 
                                            onClick={() => fileRef.current?.click()}
                                        >
                                            {t('teams.adminPage.fields.form_change')}
                                        </DefaultButton>
                                        <DefaultButton 
                                            wh={131} 
                                            whMob={107} 
                                            onClick={handleRemoveFormImage}
                                            style={{ backgroundColor: '#FF4444', color: 'white' }}
                                        >
                                            {t('teams.adminPage.fields.form_delete')}
                                        </DefaultButton>
                                    </FlexBox>
                                </>
                            ) : (
                                <>
                                    <DefaultButton 
                                        wh={131} 
                                        whMob={107} 
                                        onClick={() => fileRef.current?.click()}
                                    >
                                        {t('teams.adminPage.fields.form_add')}
                                    </DefaultButton>
                                    <FormImageInput
                                        ref={fileRef}
                                        type="file"
                                        accept="image/jpeg, image/gif, image/png"
                                        onChange={onAddImage}
                                    />
                                </>
                            )}
                        </FormImageWrapper>
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>
                
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <FlexBox style={{ gap: '8px', alignItems: 'center', width: '100%' }}>
                        <CommonInput 
                            type={INPUT_TYPES.text}
                            label={t('teams.adminPage.fields.form_address')}
                            infoText={t('teams.adminPage.additionalFields.form_link_msg')}
                            onWhiteBG
                            maxLength={200}
                            value={formAddress}
                            disable
                            onChange={(ev: any) => setFormAddress(ev.target.value)}
                            orientation="wide"
                        />
                        <CopyIcon onClick={handleCopyFormAddress}>
                            <HintTooltip positionY="top" text={t('teams.adminPage.fields.form_copy_link')} z={6} onWhiteBg={true}>
                                <CopySquareIcon24  fill="#151514" />
                            </HintTooltip>
                        </CopyIcon>
                    </FlexBox>
                </ProjectEditPageGridRow>
                
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.form_submit_button_text')}
                        maxLength={10}
                        value={getTextByLang(textSubmitButton, i18n.language)}
                        onChange={(ev: any) => setTextOnSubmitBtn(setTextByLang(textSubmitButton, i18n.language, ev.target.value))}
                        orientation="wide"
                        required
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.form_registration_limit')}
                        infoText={t('teams.adminPage.additionalFields.form_registration_limit_info')}
                        onWhiteBG
                        maxLength={10}
                        value={registrationRequestLimit}
                        onChange={(ev: any) => {
                            const value = ev.target.value;
                            if (value === '' || /^[0-9]+$/.test(value)) {
                                const numValue = Number(value);
                                if (value === '' || numValue > 0) {
                                    setRegistrationRequestLimit(value === '' ? '' : numValue);
                                }
                            }
                        }}
                        orientation="wide"
                    />
                </ProjectEditPageGridRow>
                {!!registrationRequestLimit && (
                    <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit isCheckbox>
                        <CommonLabel 
                            label={t('teams.adminPage.fields.form_show_free_places')}
                            onWhiteBG
                            fixedHeight
                        />
                        <ProjectEditPageGridInput isTeamEdit isCheckbox>
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={isRegistrationRequestLimitVisible}
                                label={''}
                                onClick={() => setIsRegistrationRequestLimitVisible(!isRegistrationRequestLimitVisible)}
                                isTeamEdit
                            />
                        </ProjectEditPageGridInput>
                    </ProjectEditPageGridRow>
                )}
                
                
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.textarea}
                        label={t('teams.adminPage.fields.form_completion_message')}
                        maxLength={200}
                        className="form-textarea"
                        value={getTextByLang(textOnComplete, i18n.language)}
                        onChange={(ev: any) => setTextOnComplete(setTextByLang(textOnComplete, i18n.language, ev.target.value))}
                        orientation="wide"
                        required
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.form_success_button_title')}
                        maxLength={30}
                        infoText={t('teams.adminPage.additionalFields.form_success_button_title_info')}
                        onWhiteBG
                        value={getTextByLang(successButtonTitle, i18n.language)}
                        onChange={(ev: any) => setSuccessButtonTitle(setTextByLang(successButtonTitle, i18n.language, ev.target.value))}
                        orientation="wide"
                        placeholder={t('teams.adminPage.fields.form_close')}
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.text}
                        label={t('teams.adminPage.fields.form_success_button_link')}
                        infoText={t('teams.adminPage.additionalFields.form_success_button_link_info')}
                        onWhiteBG
                        value={successButtonLink}
                        onChange={(ev: any) => setSuccessButtonLink(ev.target.value)}
                        onBlur={handlePathBlur}
                        orientation="wide"
                    />
                </ProjectEditPageGridRow>
                
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.textarea}
                        label={t('teams.adminPage.fields.form_pnd_agreement')}
                        maxLength={300}
                        infoText={t('teams.adminPage.additionalFields.pndFields_msg')}
                        onWhiteBG
                        //@ts-ignore
                        value={getTextByLang(pndFields, i18n.language)}
                        //@ts-ignore
                        onChange={(ev: any) => setPndFiels(setTextByLang(pndFields, i18n.language, ev.target.value))}
                        orientation="wide"
                    />
                </ProjectEditPageGridRow>
                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.form_pnd_agreement_with_checkbox')}
                        fixedHeight
                        infoText={t('teams.adminPage.additionalFields.ppdWithCheckMark_msg')}
                        onWhiteBG
                    />
                    <ProjectEditPageGridInput direction="column">
                        {ppdWithCheckMark.map((ppdField, index) => (
                            <FlexBox key={index} direction="column" offsetTop={index > 0 ? 16 : 0}>
                                <FlexBox align="center">
                                    <CommonInput 
                                        type={INPUT_TYPES.textarea}
                                        maxLength={1200}
                                        className="form-textarea"
                                        value={getTextByLang(ppdField, i18n.language)}
                                        onChange={(ev: any) => handlePpdFieldChange(index, ev.target.value)}
                                        orientation="wide"
                                    />
                                    {ppdWithCheckMark.length > 1 && (
                                        <DefaultButton 
                                            wh={100} 
                                            onClick={() => handleRemovePpdField(index)}
                                            style={{ marginLeft: 16, alignSelf: 'flex-end' }}
                                        >
                                            {t('teams.adminPage.fields.form_delete')}
                                        </DefaultButton>
                                    )}
                                </FlexBox>
                            </FlexBox>
                        ))}
                        {ppdWithCheckMark.length < 3 && (
                            <FlexBox offsetTop={16}>
                                <DefaultButton wh={180} onClick={handleAddPpdField}>
                                    {t('teams.adminPage.fields.form_add_agreement')}
                                </DefaultButton>
                            </FlexBox>
                        )}
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                    <CommonLabel
                        label={t('teams.adminPage.fields.form_ppd_check_mark_position')}
                        infoText={t('teams.adminPage.additionalFields.form_ppd_check_mark_position_msg')}
                        onWhiteBG
                        fixedHeight
                    />
                    <ProjectEditPageGridInput isTeamEdit isCheckbox>
                        <MagicBoxRow
                            className={'checkbox'}
                            checked={ppdCheckMarkPosition === FormCheckMarkPosition.Left}
                            label={''}
                            onClick={() => {
                                setPpdCheckMarkPosition(
                                    ppdCheckMarkPosition === FormCheckMarkPosition.Left
                                        ? FormCheckMarkPosition.Right
                                        : FormCheckMarkPosition.Left
                                );
                            }}
                            isTeamEdit
                        />
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isCheckbox isTeamEdit>
                    <CommonLabel
                        label={t('teams.adminPage.fields.form_ppd_check_mark_default_state')}
                        infoText={t('teams.adminPage.additionalFields.form_ppd_check_mark_default_state_msg')}
                        onWhiteBG
                        fixedHeight
                    />
                    <ProjectEditPageGridInput isTeamEdit isCheckbox>
                        <MagicBoxRow
                            className={'checkbox'}
                            checked={ppdCheckMarkDefaultState}
                            label={''}
                            onClick={() => setPpdCheckMarkDefaultState(!ppdCheckMarkDefaultState)}
                            isTeamEdit
                        />
                    </ProjectEditPageGridInput>
                </ProjectEditPageGridRow>

                {registeredUsersOnly}
                {fastRegisterWithEmail}
                {iSSendEmailNotification}
                {isProductPlatformFormField}
                {isRegisteredUsersOnly && previewPageFields}

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.textarea}
                        label={t('teams.adminPage.fields.form_email_sender_name')}
                        infoText={t('teams.adminPage.additionalFields.form_email_sender_name_info')}
                        onWhiteBG
                        maxLength={100}
                        //@ts-ignore
                        value={emailSenderName}
                        //@ts-ignore
                        onChange={(ev: any) => setEmailSenderName(ev.target.value)}
                        orientation="wide"
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.textarea}
                        label={t('teams.adminPage.fields.form_email_notification_subject')}
                        maxLength={300}
                        //@ts-ignore
                        value={getTextByLang(emailNotificationSubject, i18n.language)}
                        //@ts-ignore
                        onChange={(ev: any) => setEmailNotificationSubject(setTextByLang(emailNotificationSubject, i18n.language, ev.target.value))}
                        orientation="wide"
                        required={shouldSendEmailNotification}
                    />
                </ProjectEditPageGridRow>

                <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                    <CommonInput 
                        type={INPUT_TYPES.textarea}
                        label={t('teams.adminPage.fields.form_email_notification_text')}
                        maxLength={300}
                        //@ts-ignore
                        value={getTextByLang(emailNotificationText, i18n.language)}
                        //@ts-ignore
                        onChange={(ev: any) => setEmailNotificationText(setTextByLang(emailNotificationText, i18n.language, ev.target.value))}
                        orientation="wide"
                        required={shouldSendEmailNotification}
                    />
                </ProjectEditPageGridRow>

                <AdminEmailsToReceiveDataField
                    value={adminEmailsToReceiveData}
                    onChange={setAdminEmailsToReceiveData}
                />

            {canShowCrm && (
            <BorderBlock offsetTop={24} direction="column">
                <CommonLabel 
                        label={t('teams.adminPage.fields.crm')}
                        fixedHeight
                    />
                <ProjectEditPageGridRow isTeamEdit>
                    <CommonInput 
                            type={INPUT_TYPES.dropdown}
                            label={t('teams.adminPage.fields.form_send_to_crm')}
                            options={crmList}
                            value={crmList.find(({ value }) => value === crmName)}
                            onChange={(item: any) => setCrmName(item?.value)}
                            placeholder={t('teams.adminPage.fields.form_select_crm')}
                            orientation="wide"
                        />
                </ProjectEditPageGridRow>

                    <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                        <CommonInput 
                            type={INPUT_TYPES.text}
                            label={t('teams.adminPage.fields.form_amo_crm_funnel_id')}
                            maxLength={9}
                            value={funnelId}
                            onChange={(ev: any) => {
                              if (!crmName?.length) return;
                              const v = ev.target.value;
                              if (v === '' || !Number.isNaN(Number(v))) {
                                setFunnelId(v);
                              }
                            }}
                            disable={!crmName?.length}
                            orientation="wide"
                        />
                    </ProjectEditPageGridRow>
                    <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                        <CommonInput 
                            type={INPUT_TYPES.text}
                            label={t('teams.adminPage.fields.form_unisender_list_number')}
                            infoText={t('teams.adminPage.additionalFields.form_unisender_list_number_info')}
                            onWhiteBG
                            maxLength={30}
                            value={unisenderListNumber}
                            onChange={handleUnisenderListNumberChange}
                            orientation="wide"
                        />
                    </ProjectEditPageGridRow>
                    <ProjectEditPageGridRow style={{marginTop: isMobile? 24 : 32}} isTeamEdit>
                        <CommonInput 
                            type={INPUT_TYPES.dropdown}
                            label={t('teams.adminPage.fields.form_send_to_unisender')}
                            options={unisenderList}
                            value={unisenderList.find(({ value }) => value === unisenderName)}
                            onChange={(item: any) => setUnisenderName(item?.value)}
                            placeholder={t('teams.adminPage.fields.form_select_unisender')}
                            orientation="wide"
                        />
                    </ProjectEditPageGridRow>
                </BorderBlock>
            )}
                {event}
                <ProjectEditPageGridRow direction={'column'} directionMobile={'column'}>
                    <CommonLabel 
                        label={t('teams.adminPage.fields.form_fields')}
                        fixedHeight
                    />
                    <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit >
                        {(!!formFields?.length) && (
                            <>
                            {is1280 ? (
                                <>
                                    {formFields.map((button: any, index: number) => {
                                        return (
                                            <MobileButtonsWrapper directionMobile="row" gxMobile={24} offsetTopMobile={0} >
                                                {isS && (
                                                    <GridMobileNamed>
                                                        <span>{t('teams.adminPage.fields.form_button_number', { number: index + 1 })}</span>

                                                    </GridMobileNamed>
                                                )}
                                                <TeamsMobGridList cols={'1fr'}>
                                                    <FlexBox directionMobile="column">
                                                        <CommonInput 
                                                            type={INPUT_TYPES.dropdown}
                                                            label={t('teams.adminPage.fields.form_field_type')}
                                                            orientation="column"
                                                            value={{ label: getTypeName(button.type), value: button.type }}
                                                            onChange={(value: any) => handleSetFormFieldChange(index, 'type', value?.value)}
                                                            options={inputTypes() as any}  
                                                        />
                                                    </FlexBox>
                                                    {[4,8]?.includes(button.type) ? (
                                                        <FlexBox direction="column" directionMobile="column">
                                                            <FlexBox direction="column" directionMobile="column" gy={8} gyMobile={8}>
                                                                <FlexBox  directionMobile="column">
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.text}
                                                                        label={t('teams.adminPage.fields.form_field_header')}
                                                                        orientation="column"
                                                                        value={getTextByLang(button.header, i18n.language)}
                                                                        onChange={(ev: any) => handleSetFormFieldChange(index, 'header', ev.target.value, true)}
                                                                    />
                                                                </FlexBox>
                                                                <FlexBox  directionMobile="column">
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.text}
                                                                        label={t('teams.adminPage.fields.form_field_placeholder')}
                                                                        orientation="column"
                                                                        maxLength={FORM_FIELD_PLACEHOLDER_MAX_LENGTH}
                                                                        value={getTextByLang(button.placeholder, i18n.language)}
                                                                            onChange={(ev: any) => handleSetFormFieldChange(index, 'placeholder', ev.target.value, true)}
                                                                    />
                                                                   
                                                                </FlexBox>
                                                                <FlexBox direction={'column'} directionMobile="column">
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.text}
                                                                        label={t('teams.adminPage.fields.form_field_id')}
                                                                        orientation="column"
                                                                        className="id-input"
                                                                        value={button.fieldIdInCrm}
                                                                        //@ts-ignore
                                                                        onChange={(ev: any) => Utils.isNumber(ev, (val: any) => handleSetFormFieldChange(index, 'fieldIdInCrm', Number(val)))}
                                                                    />
                                                                </FlexBox>
                                                                <FlexBox  directionMobile="column">
                                                                    <CommonLabel 
                                                                        label={t('teams.adminPage.fields.form_field_required')}
                                                                    />
                                                                    <ProjectEditPageGridInput isTeamEdit isColumns>
                                                                        <MagicBoxRow 
                                                                            className="checkbox"
                                                                            checked={button.isRequired}
                                                                            label={''}
                                                                            onClick={() => handleSetFormFieldChange(index, 'isRequired', !button.isRequired)}
                                                                            isTeamEdit
                                                                            disabled={shouldSendEmailNotification}
                                                                            
                                                                        />
                                                                    </ProjectEditPageGridInput>
                                                                    <FlexBox alignMobile="end" offsetBottomMobile={10} offsetTopMobile={16}>
                                                                        <DefaultButton wh={131} whMob={107} onClick={() => handleDeleteFormFieldClick(index)}>{t('teams.adminPage.fields.form_delete')}</DefaultButton>
                                                                    </FlexBox>
                                                                </FlexBox>
                                                                <FlexBox  directionMobile="column">
                                                                    <CommonLabel 
                                                                        label={t('teams.adminPage.fields.form_field_is_tag')}
                                                                    />
                                                                    <ProjectEditPageGridInput isTeamEdit isColumns>
                                                                        <MagicBoxRow 
                                                                            className="checkbox"
                                                                            checked={button.isTagInCrm}
                                                                            label={''}
                                                                            onClick={() => handleSetFormFieldChange(index, 'isTagInCrm', !button.isTagInCrm)}
                                                                            isTeamEdit
                                                                            disabled={shouldSendEmailNotification}
                                                                            
                                                                        />
                                                                    </ProjectEditPageGridInput>
                                                                    <FlexBox alignMobile="end" offsetBottomMobile={10} offsetTopMobile={16}>
                                                                        <DefaultButton wh={131} whMob={107} onClick={() => handleDeleteFormFieldClick(index)}>{t('teams.adminPage.fields.form_delete')}</DefaultButton>
                                                                    </FlexBox>
                                                                </FlexBox>
                                                            </FlexBox>
                                                            <FlexBox direction="row" gx={16} gyMobile={16}>
                                                                <FlexBox alignMobile="end" offsetBottomMobile={10} offsetTopMobile={16}>
                                                                    <DefaultButton wh={131} whMob={107} onClick={() => handleEditDropdownInputs(button, index)}>{t('teams.adminPage.fields.form_edit')}</DefaultButton>
                                                                </FlexBox>
                                                                <FlexBox alignMobile="end" offsetBottomMobile={10} offsetTopMobile={16}>
                                                                    <DefaultButton wh={131} whMob={107} onClick={() => handleDeleteFormFieldClick(index)}>{t('teams.adminPage.fields.form_delete')}</DefaultButton>
                                                                </FlexBox>
                                                            </FlexBox>
                                                        </FlexBox>
                                                    ) : (
                                                        <>
                                                            <FlexBox  directionMobile="column">
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    label={t('teams.adminPage.fields.form_field_header')}
                                                                    orientation="column"
                                                                    value={getTextByLang(button.header, i18n.language)}
                                                                    onChange={(ev: any) => handleSetFormFieldChange(index, 'header', ev.target.value, true)}
                                                                /> 
                                                            </FlexBox>
                                                            <FlexBox  directionMobile="column">
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    label={t('teams.adminPage.fields.form_field_placeholder')}
                                                                    orientation="column"
                                                                    maxLength={FORM_FIELD_PLACEHOLDER_MAX_LENGTH}
                                                                    value={getTextByLang(button.placeholder, i18n.language)}
                                                                    onChange={(ev: any) => handleSetFormFieldChange(index, 'placeholder', ev.target.value, true)}
                                                                />      
                                                            </FlexBox>
                                                            <FlexBox  directionMobile="column">
                                                                <CommonLabel 
                                                                    label={t('teams.adminPage.fields.form_field_required')}
                                                                />
                                                                <ProjectEditPageGridInput isTeamEdit isColumns>
                                                                    <MagicBoxRow 
                                                                        className="checkbox"
                                                                        checked={button.isRequired}
                                                                        label={''}
                                                                        onClick={() => handleSetFormFieldChange(index, 'isRequired', !button.isRequired)}
                                                                        isTeamEdit
                                                                        disabled={shouldSendEmailNotification}
                                                                        hintsText={shouldSendEmailNotification && button.type === 2 ? t('teams.adminPage.additionalFields.form_field_email_required_hint') : undefined}
                                                                        positionY="top"
                                                                        
                                                                    />
                                                                </ProjectEditPageGridInput>
                                                                <FlexBox alignMobile="end" offsetBottomMobile={10} offsetTopMobile={16}>
                                                                    <DefaultButton wh={131} whMob={107} onClick={() => handleDeleteFormFieldClick(index)}>{t('teams.adminPage.fields.form_delete')}</DefaultButton>
                                                                </FlexBox>
                                                            </FlexBox>
                                                            <FlexBox  directionMobile="column">
                                                                    <CommonLabel 
                                                                        label={t('teams.adminPage.fields.form_field_is_tag')}
                                                                    />
                                                                    <ProjectEditPageGridInput isTeamEdit isColumns>
                                                                        <MagicBoxRow 
                                                                            className="checkbox"
                                                                            checked={button.isTagInCrm}
                                                                            label={''}
                                                                            onClick={() => handleSetFormFieldChange(index, 'isTagInCrm', !button.isTagInCrm)}
                                                                            isTeamEdit
                                                                            disabled={shouldSendEmailNotification}
                                                                            
                                                                        />
                                                                    </ProjectEditPageGridInput>
                                                                    <FlexBox alignMobile="end" offsetBottomMobile={10} offsetTopMobile={16}>
                                                                        <DefaultButton wh={131} whMob={107} onClick={() => handleDeleteFormFieldClick(index)}>{t('teams.adminPage.fields.form_delete')}</DefaultButton>
                                                                    </FlexBox>
                                                            </FlexBox>
                                                        </>
                                                    )}

                                                </TeamsMobGridList>

                                            </MobileButtonsWrapper>

                                        )})}
                                    </> 
                            ) : (
                                <JustTable isTeamEdit>
                                    <thead>
                                        <tr>
                                            <th style={{width: '25%'}}>{t('teams.adminPage.fields.form_field_type')}</th>
                                            <th style={{width: '20%'}}>{t('teams.adminPage.fields.form_field_header')}</th>
                                            <th style={{width: '20%'}}>{t('teams.adminPage.fields.form_field_placeholder')}</th>
                                            <th style={{width: '15%'}}>{t('teams.adminPage.fields.form_field_crm_id')}</th>
                                            <th style={{width: '10%'}}>{t('teams.adminPage.fields.form_field_required')}</th>
                                            <th style={{width: '10%'}}>{t('teams.adminPage.fields.form_field_crm_tag')}</th>
                                            <th style={{width: '10%'}}></th>
                                        </tr>
                                    </thead>
                                    {/* <TBody isFormEdit> */}
                                        <SortableList as={'tbody'} onSortEnd={onMoveOption}>
                                        {formFields.map((button: any, index: any) => {
                                            return (
                                                <SortableItem key={"dropdown-edit-sortable_" + index}>
                                                <tr>
                                                    <td>
                                                        <FlexBox direction='row' align="center" gx={16}>
                                                            <SortableKnob>
                                                                <div style={{cursor: 'grab', backgroundColor: 'transparent' }}>
                                                                    <DottedIcon />
                                                                </div>
                                                            </SortableKnob>                                                        
                                                            <CommonInput 
                                                                type={INPUT_TYPES.dropdown}
                                                                value={{ label: getTypeName(button.type), value: button.type }}
                                                                onChange={(value: any) => handleSetFormFieldChange(index, 'type', value?.value)}
                                                                options={inputTypes() as any}
                                                            />
                                                        </FlexBox>
                                                    </td>
                                                    {[8,4]?.includes(button.type) ? (
                                                        <>
                                                            <td>
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    value={getTextByLang(button.header, i18n.language)}
                                                                        onChange={(ev: any) => handleSetFormFieldChange(index, 'header', ev.target.value, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    maxLength={FORM_FIELD_PLACEHOLDER_MAX_LENGTH}
                                                                    value={getTextByLang(button.placeholder, i18n.language)}
                                                                    onChange={(ev: any) => handleSetFormFieldChange(index, 'placeholder', ev.target.value, true)}
                                                                />
                                                            </td>
                                                            <td>       
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    value={button.fieldIdInCrm}
                                                                        //@ts-ignore
                                                                    onChange={(ev: any) => Utils.isNumber(ev, (val: any) => handleSetFormFieldChange(index, 'fieldIdInCrm', Number(val)))}
                                                                />
                                                            </td>
                                                            <td style={{ width: isS ? '70px' : '150px' }}>
                                                                <FlexBox justify={'center'}>
                                                                    <MagicBoxRow
                                                                        className="checkbox"
                                                                        checked={button.isRequired}
                                                                        label={''}
                                                                        onClick={() => handleSetFormFieldChange(index, 'isRequired', !button.isRequired)}
                                                                        isTeamEdit
                                                                        
                                                                    />
                                                                </FlexBox>
                                                            </td>
                                                            <td style={{ width: isS ? '70px' : '150px' }}>
                                                                <FlexBox justify={'center'}>
                                                                    <MagicBoxRow
                                                                        className="checkbox"
                                                                        checked={button.isTagInCrm}
                                                                        label={''}
                                                                        onClick={() => handleSetFormFieldChange(index, 'isTagInCrm', !button.isTagInCrm)}
                                                                        isTeamEdit
                                                                        
                                                                    />
                                                                </FlexBox>
                                                            </td>
                                                            <td>
                                                                <FlexBox direction="row" gx={16}>
                                                                    <EditIcon24 onClick={() => handleEditDropdownInputs(button, index)}/>
                                                                    <DeleteIcon onClick={() => handleDeleteFormFieldClick(index)}/>
                                                                </FlexBox>
                                                            </td>
                                                        </>
                                                    ) : [0]?.includes(button.type) ? (
                                                        <>
                                                            <td>
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    value={getTextByLang(button.header, i18n.language)}
                                                                    onChange={(ev: any) => handleSetFormFieldChange(index, 'header', ev.target.value, true)}
                                                                />
                                                              
                                                            </td>
                                                            <td>
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    maxLength={FORM_FIELD_PLACEHOLDER_MAX_LENGTH}
                                                                    value={getTextByLang(button.placeholder, i18n.language)}
                                                                    onChange={(ev: any) => handleSetFormFieldChange(index, 'placeholder', ev.target.value, true)}
                                                                />
                                                            </td>
                                                            <td> 
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    value={button.fieldIdInCrm}
                                                                    //@ts-ignore
                                                                    onChange={(ev: any) => Utils.isNumber(ev, (val: any) => handleSetFormFieldChange(index, 'fieldIdInCrm', Number(val)))}
                                                                />
                                                            </td>
                                                            <td style={{ width: isS ? '70px' : '168px', position: 'relative' }}>
                                                                <FlexBox justify={'center'}>
                                                                    <MagicBoxRow 
                                                                        className="checkbox"
                                                                        checked={button.isRequired}
                                                                        label={''}
                                                                        onClick={() => handleSetFormFieldChange(index, 'isRequired', !button.isRequired)}
                                                                        isTeamEdit
                                                                        disabled={shouldSendEmailNotification && button.type === 2}
                                                                        hintsText={shouldSendEmailNotification && button.type === 2 ? t('teams.adminPage.additionalFields.form_field_email_required_hint') : undefined}
                                                                        positionY="top"
                                                                    />
                                                                </FlexBox>
                                                            </td>
                                                             <td style={{ width: isS ? '70px' : '168px' }}>
                                                                <FlexBox justify={'center'}>
                                                                    <MagicBoxRow
                                                                        className="checkbox"
                                                                        checked={button.isTagInCrm}
                                                                        label={''}
                                                                        onClick={() => handleSetFormFieldChange(index, 'isTagInCrm', !button.isTagInCrm)}
                                                                        isTeamEdit
                                                                        
                                                                    />
                                                                </FlexBox>
                                                            </td>
                                                            <td>
                                                                <DefaultButton disabled={shouldSendEmailNotification && button.type === 2} wh={131} whMob={107} onClick={() => handleDeleteFormFieldClick(index)}>{t('teams.adminPage.fields.form_delete')}</DefaultButton>
                                                            </td>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <td>
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    value={getTextByLang(button.header, i18n.language)}
                                                                    onChange={(ev: any) => handleSetFormFieldChange(index, 'header', ev.target.value, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    maxLength={FORM_FIELD_PLACEHOLDER_MAX_LENGTH}
                                                                    value={getTextByLang(button.placeholder, i18n.language)}
                                                                    onChange={(ev: any) => handleSetFormFieldChange(index, 'placeholder', ev.target.value, true)}
                                                                />                
                                                            </td>
                                                            <td>-</td>
                                                            <td style={{ width: isS ? '70px' : '168px', position: 'relative' }}>
                                                                <FlexBox justify={'center'}>
                                                                    <MagicBoxRow 
                                                                        className="checkbox"
                                                                        checked={button.isRequired}
                                                                        label={''}
                                                                        onClick={() => handleSetFormFieldChange(index, 'isRequired', !button.isRequired)}
                                                                        isTeamEdit
                                                                        disabled={shouldSendEmailNotification && button.type === 2}
                                                                        hintsText={shouldSendEmailNotification && button.type === 2 ? t('teams.adminPage.additionalFields.form_field_email_required_hint') : undefined}
                                                                        positionY="top"
                                                                    />
                                                                </FlexBox>
                                                            </td>
                                                             <td style={{ width: isS ? '70px' : '168px' }}>
                                                                <FlexBox justify={'center'}>
                                                                    <MagicBoxRow
                                                                        className="checkbox"
                                                                        checked={button.isTagInCrm}
                                                                        label={''}
                                                                        onClick={() => handleSetFormFieldChange(index, 'isTagInCrm', !button.isTagInCrm)}
                                                                        isTeamEdit
                                                                        
                                                                    />
                                                                </FlexBox>
                                                            </td>
                                                            <td>
                                                                <DefaultButton disabled={shouldSendEmailNotification && button.type === 2} wh={131} whMob={107} onClick={() => handleDeleteFormFieldClick(index)}>{t('teams.adminPage.fields.form_delete')}</DefaultButton>
                                                            </td>
                                                        </>
                                                    )}

                                                </tr>
                                                </SortableItem>
                                            );
                                        })}
                                        </SortableList>
                                    {/* </TBody> */}
                                </JustTable>
                            )}
                            </>
                        )}
                            <FlexBox offsetTop={24} offsetTopMobile={14}>
                                <DefaultButton wh={131} whMob={107} onClick={() => handleNewFieldClick()}>
                                    {(isS && !!formFields?.length) && <PlusSvg /> }
                                    {t('teams.adminPage.fields.form_add_field')}
                                </DefaultButton>
                            </FlexBox>
                        </ProjectEditPageGridList>
                            
                </ProjectEditPageGridRow>
            </ProjectEditPageGrid>
     
        {/*</PageViewportLayout>*/}
        </>
    );
};
